import { p as G, B as Dn, g as Dr, b as $i, u as vi, a as Ti } from "./errors-CoLhPo2G.js";
import jn from "crypto";
const ki = globalThis || void 0 || self;
function jr(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
const { toString: Ni } = Object.prototype, { getPrototypeOf: Mn } = Object, Ft = /* @__PURE__ */ ((t) => (e) => {
  const n = Ni.call(e);
  return t[n] || (t[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), V = (t) => (t = t.toLowerCase(), (e) => Ft(e) === t), It = (t) => (e) => typeof e === t, { isArray: Oe } = Array, Le = It("undefined");
function Ri(t) {
  return t !== null && !Le(t) && t.constructor !== null && !Le(t.constructor) && _(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const Mr = V("ArrayBuffer");
function Pi(t) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && Mr(t.buffer), e;
}
const Ci = It("string"), _ = It("function"), Br = It("number"), Lt = (t) => t !== null && typeof t == "object", Fi = (t) => t === !0 || t === !1, ut = (t) => {
  if (Ft(t) !== "object")
    return !1;
  const e = Mn(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}, Ii = V("Date"), Li = V("File"), Di = V("Blob"), ji = V("FileList"), Mi = (t) => Lt(t) && _(t.pipe), Bi = (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || _(t.append) && ((e = Ft(t)) === "formdata" || // detect form-data instance
  e === "object" && _(t.toString) && t.toString() === "[object FormData]"));
}, _i = V("URLSearchParams"), [Ui, xi, qi, Ji] = ["ReadableStream", "Request", "Response", "Headers"].map(V), zi = (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Ue(t, e, { allOwnKeys: n = !1 } = {}) {
  if (t === null || typeof t > "u")
    return;
  let r, s;
  if (typeof t != "object" && (t = [t]), Oe(t))
    for (r = 0, s = t.length; r < s; r++)
      e.call(null, t[r], r, t);
  else {
    const i = n ? Object.getOwnPropertyNames(t) : Object.keys(t), o = i.length;
    let a;
    for (r = 0; r < o; r++)
      a = i[r], e.call(null, t[a], a, t);
  }
}
function _r(t, e) {
  e = e.toLowerCase();
  const n = Object.keys(t);
  let r = n.length, s;
  for (; r-- > 0; )
    if (s = n[r], e === s.toLowerCase())
      return s;
  return null;
}
const ie = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : ki, Ur = (t) => !Le(t) && t !== ie;
function Sn() {
  const { caseless: t } = Ur(this) && this || {}, e = {}, n = (r, s) => {
    const i = t && _r(e, s) || s;
    ut(e[i]) && ut(r) ? e[i] = Sn(e[i], r) : ut(r) ? e[i] = Sn({}, r) : Oe(r) ? e[i] = r.slice() : e[i] = r;
  };
  for (let r = 0, s = arguments.length; r < s; r++)
    arguments[r] && Ue(arguments[r], n);
  return e;
}
const Wi = (t, e, n, { allOwnKeys: r } = {}) => (Ue(e, (s, i) => {
  n && _(s) ? t[i] = jr(s, n) : t[i] = s;
}, { allOwnKeys: r }), t), Hi = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), Vi = (t, e, n, r) => {
  t.prototype = Object.create(e.prototype, r), t.prototype.constructor = t, Object.defineProperty(t, "super", {
    value: e.prototype
  }), n && Object.assign(t.prototype, n);
}, Ki = (t, e, n, r) => {
  let s, i, o;
  const a = {};
  if (e = e || {}, t == null) return e;
  do {
    for (s = Object.getOwnPropertyNames(t), i = s.length; i-- > 0; )
      o = s[i], (!r || r(o, t, e)) && !a[o] && (e[o] = t[o], a[o] = !0);
    t = n !== !1 && Mn(t);
  } while (t && (!n || n(t, e)) && t !== Object.prototype);
  return e;
}, Qi = (t, e, n) => {
  t = String(t), (n === void 0 || n > t.length) && (n = t.length), n -= e.length;
  const r = t.indexOf(e, n);
  return r !== -1 && r === n;
}, Xi = (t) => {
  if (!t) return null;
  if (Oe(t)) return t;
  let e = t.length;
  if (!Br(e)) return null;
  const n = new Array(e);
  for (; e-- > 0; )
    n[e] = t[e];
  return n;
}, Gi = /* @__PURE__ */ ((t) => (e) => t && e instanceof t)(typeof Uint8Array < "u" && Mn(Uint8Array)), Yi = (t, e) => {
  const r = (t && t[Symbol.iterator]).call(t);
  let s;
  for (; (s = r.next()) && !s.done; ) {
    const i = s.value;
    e.call(t, i[0], i[1]);
  }
}, Zi = (t, e) => {
  let n;
  const r = [];
  for (; (n = t.exec(e)) !== null; )
    r.push(n);
  return r;
}, eo = V("HTMLFormElement"), to = (t) => t.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, s) {
    return r.toUpperCase() + s;
  }
), sr = (({ hasOwnProperty: t }) => (e, n) => t.call(e, n))(Object.prototype), no = V("RegExp"), xr = (t, e) => {
  const n = Object.getOwnPropertyDescriptors(t), r = {};
  Ue(n, (s, i) => {
    let o;
    (o = e(s, i, t)) !== !1 && (r[i] = o || s);
  }), Object.defineProperties(t, r);
}, ro = (t) => {
  xr(t, (e, n) => {
    if (_(t) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = t[n];
    if (_(r)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, so = (t, e) => {
  const n = {}, r = (s) => {
    s.forEach((i) => {
      n[i] = !0;
    });
  };
  return Oe(t) ? r(t) : r(String(t).split(e)), n;
}, io = () => {
}, oo = (t, e) => t != null && Number.isFinite(t = +t) ? t : e;
function ao(t) {
  return !!(t && _(t.append) && t[Symbol.toStringTag] === "FormData" && t[Symbol.iterator]);
}
const co = (t) => {
  const e = new Array(10), n = (r, s) => {
    if (Lt(r)) {
      if (e.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        e[s] = r;
        const i = Oe(r) ? [] : {};
        return Ue(r, (o, a) => {
          const c = n(o, s + 1);
          !Le(c) && (i[a] = c);
        }), e[s] = void 0, i;
      }
    }
    return r;
  };
  return n(t, 0);
}, lo = V("AsyncFunction"), fo = (t) => t && (Lt(t) || _(t)) && _(t.then) && _(t.catch), qr = ((t, e) => t ? setImmediate : e ? ((n, r) => (ie.addEventListener("message", ({ source: s, data: i }) => {
  s === ie && i === n && r.length && r.shift()();
}, !1), (s) => {
  r.push(s), ie.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  _(ie.postMessage)
), uo = typeof queueMicrotask < "u" ? queueMicrotask.bind(ie) : typeof G < "u" && G.nextTick || qr, d = {
  isArray: Oe,
  isArrayBuffer: Mr,
  isBuffer: Ri,
  isFormData: Bi,
  isArrayBufferView: Pi,
  isString: Ci,
  isNumber: Br,
  isBoolean: Fi,
  isObject: Lt,
  isPlainObject: ut,
  isReadableStream: Ui,
  isRequest: xi,
  isResponse: qi,
  isHeaders: Ji,
  isUndefined: Le,
  isDate: Ii,
  isFile: Li,
  isBlob: Di,
  isRegExp: no,
  isFunction: _,
  isStream: Mi,
  isURLSearchParams: _i,
  isTypedArray: Gi,
  isFileList: ji,
  forEach: Ue,
  merge: Sn,
  extend: Wi,
  trim: zi,
  stripBOM: Hi,
  inherits: Vi,
  toFlatObject: Ki,
  kindOf: Ft,
  kindOfTest: V,
  endsWith: Qi,
  toArray: Xi,
  forEachEntry: Yi,
  matchAll: Zi,
  isHTMLForm: eo,
  hasOwnProperty: sr,
  hasOwnProp: sr,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: xr,
  freezeMethods: ro,
  toObjectSet: so,
  toCamelCase: to,
  noop: io,
  toFiniteNumber: oo,
  findKey: _r,
  global: ie,
  isContextDefined: Ur,
  isSpecCompliantForm: ao,
  toJSONObject: co,
  isAsyncFn: lo,
  isThenable: fo,
  setImmediate: qr,
  asap: uo
};
function $(t, e, n, r, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), n && (this.config = n), r && (this.request = r), s && (this.response = s, this.status = s.status ? s.status : null);
}
d.inherits($, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: d.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Jr = $.prototype, zr = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((t) => {
  zr[t] = { value: t };
});
Object.defineProperties($, zr);
Object.defineProperty(Jr, "isAxiosError", { value: !0 });
$.from = (t, e, n, r, s, i) => {
  const o = Object.create(Jr);
  return d.toFlatObject(t, o, function(c) {
    return c !== Error.prototype;
  }, (a) => a !== "isAxiosError"), $.call(o, t.message, e, n, r, s), o.cause = t, o.name = t.name, i && Object.assign(o, i), o;
};
const ho = null;
function En(t) {
  return d.isPlainObject(t) || d.isArray(t);
}
function Wr(t) {
  return d.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function ir(t, e, n) {
  return t ? t.concat(e).map(function(s, i) {
    return s = Wr(s), !n && i ? "[" + s + "]" : s;
  }).join(n ? "." : "") : e;
}
function mo(t) {
  return d.isArray(t) && !t.some(En);
}
const po = d.toFlatObject(d, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function Dt(t, e, n) {
  if (!d.isObject(t))
    throw new TypeError("target must be an object");
  e = e || new FormData(), n = d.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(p, y) {
    return !d.isUndefined(y[p]);
  });
  const r = n.metaTokens, s = n.visitor || f, i = n.dots, o = n.indexes, c = (n.Blob || typeof Blob < "u" && Blob) && d.isSpecCompliantForm(e);
  if (!d.isFunction(s))
    throw new TypeError("visitor must be a function");
  function l(h) {
    if (h === null) return "";
    if (d.isDate(h))
      return h.toISOString();
    if (!c && d.isBlob(h))
      throw new $("Blob is not supported. Use a Buffer instead.");
    return d.isArrayBuffer(h) || d.isTypedArray(h) ? c && typeof Blob == "function" ? new Blob([h]) : Dn.from(h) : h;
  }
  function f(h, p, y) {
    let O = h;
    if (h && !y && typeof h == "object") {
      if (d.endsWith(p, "{}"))
        p = r ? p : p.slice(0, -2), h = JSON.stringify(h);
      else if (d.isArray(h) && mo(h) || (d.isFileList(h) || d.endsWith(p, "[]")) && (O = d.toArray(h)))
        return p = Wr(p), O.forEach(function(E, S) {
          !(d.isUndefined(E) || E === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? ir([p], S, i) : o === null ? p : p + "[]",
            l(E)
          );
        }), !1;
    }
    return En(h) ? !0 : (e.append(ir(y, p, i), l(h)), !1);
  }
  const u = [], m = Object.assign(po, {
    defaultVisitor: f,
    convertValue: l,
    isVisitable: En
  });
  function g(h, p) {
    if (!d.isUndefined(h)) {
      if (u.indexOf(h) !== -1)
        throw Error("Circular reference detected in " + p.join("."));
      u.push(h), d.forEach(h, function(O, w) {
        (!(d.isUndefined(O) || O === null) && s.call(
          e,
          O,
          d.isString(w) ? w.trim() : w,
          p,
          m
        )) === !0 && g(O, p ? p.concat(w) : [w]);
      }), u.pop();
    }
  }
  if (!d.isObject(t))
    throw new TypeError("data must be an object");
  return g(t), e;
}
function or(t) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(r) {
    return e[r];
  });
}
function Bn(t, e) {
  this._pairs = [], t && Dt(t, this, e);
}
const Hr = Bn.prototype;
Hr.append = function(e, n) {
  this._pairs.push([e, n]);
};
Hr.toString = function(e) {
  const n = e ? function(r) {
    return e.call(this, r, or);
  } : or;
  return this._pairs.map(function(s) {
    return n(s[0]) + "=" + n(s[1]);
  }, "").join("&");
};
function yo(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Vr(t, e, n) {
  if (!e)
    return t;
  const r = n && n.encode || yo;
  d.isFunction(n) && (n = {
    serialize: n
  });
  const s = n && n.serialize;
  let i;
  if (s ? i = s(e, n) : i = d.isURLSearchParams(e) ? e.toString() : new Bn(e, n).toString(r), i) {
    const o = t.indexOf("#");
    o !== -1 && (t = t.slice(0, o)), t += (t.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return t;
}
class ar {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, n, r) {
    return this.handlers.push({
      fulfilled: e,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    d.forEach(this.handlers, function(r) {
      r !== null && e(r);
    });
  }
}
const Kr = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, go = typeof URLSearchParams < "u" ? URLSearchParams : Bn, wo = typeof FormData < "u" ? FormData : null, bo = typeof Blob < "u" ? Blob : null, So = {
  isBrowser: !0,
  classes: {
    URLSearchParams: go,
    FormData: wo,
    Blob: bo
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, _n = typeof window < "u" && typeof document < "u", On = typeof navigator == "object" && navigator || void 0, Eo = _n && (!On || ["ReactNative", "NativeScript", "NS"].indexOf(On.product) < 0), Oo = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Ao = _n && window.location.href || "http://localhost", $o = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: _n,
  hasStandardBrowserEnv: Eo,
  hasStandardBrowserWebWorkerEnv: Oo,
  navigator: On,
  origin: Ao
}, Symbol.toStringTag, { value: "Module" })), F = {
  ...$o,
  ...So
};
function vo(t, e) {
  return Dt(t, new F.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, s, i) {
      return F.isNode && d.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
function To(t) {
  return d.matchAll(/\w+|\[(\w*)]/g, t).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function ko(t) {
  const e = {}, n = Object.keys(t);
  let r;
  const s = n.length;
  let i;
  for (r = 0; r < s; r++)
    i = n[r], e[i] = t[i];
  return e;
}
function Qr(t) {
  function e(n, r, s, i) {
    let o = n[i++];
    if (o === "__proto__") return !0;
    const a = Number.isFinite(+o), c = i >= n.length;
    return o = !o && d.isArray(s) ? s.length : o, c ? (d.hasOwnProp(s, o) ? s[o] = [s[o], r] : s[o] = r, !a) : ((!s[o] || !d.isObject(s[o])) && (s[o] = []), e(n, r, s[o], i) && d.isArray(s[o]) && (s[o] = ko(s[o])), !a);
  }
  if (d.isFormData(t) && d.isFunction(t.entries)) {
    const n = {};
    return d.forEachEntry(t, (r, s) => {
      e(To(r), s, n, 0);
    }), n;
  }
  return null;
}
function No(t, e, n) {
  if (d.isString(t))
    try {
      return (e || JSON.parse)(t), d.trim(t);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(t);
}
const xe = {
  transitional: Kr,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, n) {
    const r = n.getContentType() || "", s = r.indexOf("application/json") > -1, i = d.isObject(e);
    if (i && d.isHTMLForm(e) && (e = new FormData(e)), d.isFormData(e))
      return s ? JSON.stringify(Qr(e)) : e;
    if (d.isArrayBuffer(e) || d.isBuffer(e) || d.isStream(e) || d.isFile(e) || d.isBlob(e) || d.isReadableStream(e))
      return e;
    if (d.isArrayBufferView(e))
      return e.buffer;
    if (d.isURLSearchParams(e))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let a;
    if (i) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return vo(e, this.formSerializer).toString();
      if ((a = d.isFileList(e)) || r.indexOf("multipart/form-data") > -1) {
        const c = this.env && this.env.FormData;
        return Dt(
          a ? { "files[]": e } : e,
          c && new c(),
          this.formSerializer
        );
      }
    }
    return i || s ? (n.setContentType("application/json", !1), No(e)) : e;
  }],
  transformResponse: [function(e) {
    const n = this.transitional || xe.transitional, r = n && n.forcedJSONParsing, s = this.responseType === "json";
    if (d.isResponse(e) || d.isReadableStream(e))
      return e;
    if (e && d.isString(e) && (r && !this.responseType || s)) {
      const o = !(n && n.silentJSONParsing) && s;
      try {
        return JSON.parse(e);
      } catch (a) {
        if (o)
          throw a.name === "SyntaxError" ? $.from(a, $.ERR_BAD_RESPONSE, this, null, this.response) : a;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: F.classes.FormData,
    Blob: F.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
d.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  xe.headers[t] = {};
});
const Ro = d.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Po = (t) => {
  const e = {};
  let n, r, s;
  return t && t.split(`
`).forEach(function(o) {
    s = o.indexOf(":"), n = o.substring(0, s).trim().toLowerCase(), r = o.substring(s + 1).trim(), !(!n || e[n] && Ro[n]) && (n === "set-cookie" ? e[n] ? e[n].push(r) : e[n] = [r] : e[n] = e[n] ? e[n] + ", " + r : r);
  }), e;
}, cr = Symbol("internals");
function Ne(t) {
  return t && String(t).trim().toLowerCase();
}
function dt(t) {
  return t === !1 || t == null ? t : d.isArray(t) ? t.map(dt) : String(t);
}
function Co(t) {
  const e = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(t); )
    e[r[1]] = r[2];
  return e;
}
const Fo = (t) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim());
function cn(t, e, n, r, s) {
  if (d.isFunction(r))
    return r.call(this, e, n);
  if (s && (e = n), !!d.isString(e)) {
    if (d.isString(r))
      return e.indexOf(r) !== -1;
    if (d.isRegExp(r))
      return r.test(e);
  }
}
function Io(t) {
  return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, n, r) => n.toUpperCase() + r);
}
function Lo(t, e) {
  const n = d.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(t, r + n, {
      value: function(s, i, o) {
        return this[r].call(this, e, s, i, o);
      },
      configurable: !0
    });
  });
}
class M {
  constructor(e) {
    e && this.set(e);
  }
  set(e, n, r) {
    const s = this;
    function i(a, c, l) {
      const f = Ne(c);
      if (!f)
        throw new Error("header name must be a non-empty string");
      const u = d.findKey(s, f);
      (!u || s[u] === void 0 || l === !0 || l === void 0 && s[u] !== !1) && (s[u || c] = dt(a));
    }
    const o = (a, c) => d.forEach(a, (l, f) => i(l, f, c));
    if (d.isPlainObject(e) || e instanceof this.constructor)
      o(e, n);
    else if (d.isString(e) && (e = e.trim()) && !Fo(e))
      o(Po(e), n);
    else if (d.isHeaders(e))
      for (const [a, c] of e.entries())
        i(c, a, r);
    else
      e != null && i(n, e, r);
    return this;
  }
  get(e, n) {
    if (e = Ne(e), e) {
      const r = d.findKey(this, e);
      if (r) {
        const s = this[r];
        if (!n)
          return s;
        if (n === !0)
          return Co(s);
        if (d.isFunction(n))
          return n.call(this, s, r);
        if (d.isRegExp(n))
          return n.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, n) {
    if (e = Ne(e), e) {
      const r = d.findKey(this, e);
      return !!(r && this[r] !== void 0 && (!n || cn(this, this[r], r, n)));
    }
    return !1;
  }
  delete(e, n) {
    const r = this;
    let s = !1;
    function i(o) {
      if (o = Ne(o), o) {
        const a = d.findKey(r, o);
        a && (!n || cn(r, r[a], a, n)) && (delete r[a], s = !0);
      }
    }
    return d.isArray(e) ? e.forEach(i) : i(e), s;
  }
  clear(e) {
    const n = Object.keys(this);
    let r = n.length, s = !1;
    for (; r--; ) {
      const i = n[r];
      (!e || cn(this, this[i], i, e, !0)) && (delete this[i], s = !0);
    }
    return s;
  }
  normalize(e) {
    const n = this, r = {};
    return d.forEach(this, (s, i) => {
      const o = d.findKey(r, i);
      if (o) {
        n[o] = dt(s), delete n[i];
        return;
      }
      const a = e ? Io(i) : String(i).trim();
      a !== i && delete n[i], n[a] = dt(s), r[a] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const n = /* @__PURE__ */ Object.create(null);
    return d.forEach(this, (r, s) => {
      r != null && r !== !1 && (n[s] = e && d.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, n]) => e + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...n) {
    const r = new this(e);
    return n.forEach((s) => r.set(s)), r;
  }
  static accessor(e) {
    const r = (this[cr] = this[cr] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function i(o) {
      const a = Ne(o);
      r[a] || (Lo(s, o), r[a] = !0);
    }
    return d.isArray(e) ? e.forEach(i) : i(e), this;
  }
}
M.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
d.reduceDescriptors(M.prototype, ({ value: t }, e) => {
  let n = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => t,
    set(r) {
      this[n] = r;
    }
  };
});
d.freezeMethods(M);
function ln(t, e) {
  const n = this || xe, r = e || n, s = M.from(r.headers);
  let i = r.data;
  return d.forEach(t, function(a) {
    i = a.call(n, i, s.normalize(), e ? e.status : void 0);
  }), s.normalize(), i;
}
function Xr(t) {
  return !!(t && t.__CANCEL__);
}
function Ae(t, e, n) {
  $.call(this, t ?? "canceled", $.ERR_CANCELED, e, n), this.name = "CanceledError";
}
d.inherits(Ae, $, {
  __CANCEL__: !0
});
function Gr(t, e, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? t(n) : e(new $(
    "Request failed with status code " + n.status,
    [$.ERR_BAD_REQUEST, $.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function Do(t) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return e && e[1] || "";
}
function jo(t, e) {
  t = t || 10;
  const n = new Array(t), r = new Array(t);
  let s = 0, i = 0, o;
  return e = e !== void 0 ? e : 1e3, function(c) {
    const l = Date.now(), f = r[i];
    o || (o = l), n[s] = c, r[s] = l;
    let u = i, m = 0;
    for (; u !== s; )
      m += n[u++], u = u % t;
    if (s = (s + 1) % t, s === i && (i = (i + 1) % t), l - o < e)
      return;
    const g = f && l - f;
    return g ? Math.round(m * 1e3 / g) : void 0;
  };
}
function Mo(t, e) {
  let n = 0, r = 1e3 / e, s, i;
  const o = (l, f = Date.now()) => {
    n = f, s = null, i && (clearTimeout(i), i = null), t.apply(null, l);
  };
  return [(...l) => {
    const f = Date.now(), u = f - n;
    u >= r ? o(l, f) : (s = l, i || (i = setTimeout(() => {
      i = null, o(s);
    }, r - u)));
  }, () => s && o(s)];
}
const gt = (t, e, n = 3) => {
  let r = 0;
  const s = jo(50, 250);
  return Mo((i) => {
    const o = i.loaded, a = i.lengthComputable ? i.total : void 0, c = o - r, l = s(c), f = o <= a;
    r = o;
    const u = {
      loaded: o,
      total: a,
      progress: a ? o / a : void 0,
      bytes: c,
      rate: l || void 0,
      estimated: l && a && f ? (a - o) / l : void 0,
      event: i,
      lengthComputable: a != null,
      [e ? "download" : "upload"]: !0
    };
    t(u);
  }, n);
}, lr = (t, e) => {
  const n = t != null;
  return [(r) => e[0]({
    lengthComputable: n,
    total: t,
    loaded: r
  }), e[1]];
}, fr = (t) => (...e) => d.asap(() => t(...e)), Bo = F.hasStandardBrowserEnv ? /* @__PURE__ */ ((t, e) => (n) => (n = new URL(n, F.origin), t.protocol === n.protocol && t.host === n.host && (e || t.port === n.port)))(
  new URL(F.origin),
  F.navigator && /(msie|trident)/i.test(F.navigator.userAgent)
) : () => !0, _o = F.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(t, e, n, r, s, i) {
      const o = [t + "=" + encodeURIComponent(e)];
      d.isNumber(n) && o.push("expires=" + new Date(n).toGMTString()), d.isString(r) && o.push("path=" + r), d.isString(s) && o.push("domain=" + s), i === !0 && o.push("secure"), document.cookie = o.join("; ");
    },
    read(t) {
      const e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove(t) {
      this.write(t, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Uo(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
function xo(t, e) {
  return e ? t.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : t;
}
function Yr(t, e, n) {
  let r = !Uo(e);
  return t && r || n == !1 ? xo(t, e) : e;
}
const ur = (t) => t instanceof M ? { ...t } : t;
function fe(t, e) {
  e = e || {};
  const n = {};
  function r(l, f, u, m) {
    return d.isPlainObject(l) && d.isPlainObject(f) ? d.merge.call({ caseless: m }, l, f) : d.isPlainObject(f) ? d.merge({}, f) : d.isArray(f) ? f.slice() : f;
  }
  function s(l, f, u, m) {
    if (d.isUndefined(f)) {
      if (!d.isUndefined(l))
        return r(void 0, l, u, m);
    } else return r(l, f, u, m);
  }
  function i(l, f) {
    if (!d.isUndefined(f))
      return r(void 0, f);
  }
  function o(l, f) {
    if (d.isUndefined(f)) {
      if (!d.isUndefined(l))
        return r(void 0, l);
    } else return r(void 0, f);
  }
  function a(l, f, u) {
    if (u in e)
      return r(l, f);
    if (u in t)
      return r(void 0, l);
  }
  const c = {
    url: i,
    method: i,
    data: i,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: a,
    headers: (l, f, u) => s(ur(l), ur(f), u, !0)
  };
  return d.forEach(Object.keys(Object.assign({}, t, e)), function(f) {
    const u = c[f] || s, m = u(t[f], e[f], f);
    d.isUndefined(m) && u !== a || (n[f] = m);
  }), n;
}
const Zr = (t) => {
  const e = fe({}, t);
  let { data: n, withXSRFToken: r, xsrfHeaderName: s, xsrfCookieName: i, headers: o, auth: a } = e;
  e.headers = o = M.from(o), e.url = Vr(Yr(e.baseURL, e.url), t.params, t.paramsSerializer), a && o.set(
    "Authorization",
    "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))
  );
  let c;
  if (d.isFormData(n)) {
    if (F.hasStandardBrowserEnv || F.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if ((c = o.getContentType()) !== !1) {
      const [l, ...f] = c ? c.split(";").map((u) => u.trim()).filter(Boolean) : [];
      o.setContentType([l || "multipart/form-data", ...f].join("; "));
    }
  }
  if (F.hasStandardBrowserEnv && (r && d.isFunction(r) && (r = r(e)), r || r !== !1 && Bo(e.url))) {
    const l = s && i && _o.read(i);
    l && o.set(s, l);
  }
  return e;
}, qo = typeof XMLHttpRequest < "u", Jo = qo && function(t) {
  return new Promise(function(n, r) {
    const s = Zr(t);
    let i = s.data;
    const o = M.from(s.headers).normalize();
    let { responseType: a, onUploadProgress: c, onDownloadProgress: l } = s, f, u, m, g, h;
    function p() {
      g && g(), h && h(), s.cancelToken && s.cancelToken.unsubscribe(f), s.signal && s.signal.removeEventListener("abort", f);
    }
    let y = new XMLHttpRequest();
    y.open(s.method.toUpperCase(), s.url, !0), y.timeout = s.timeout;
    function O() {
      if (!y)
        return;
      const E = M.from(
        "getAllResponseHeaders" in y && y.getAllResponseHeaders()
      ), b = {
        data: !a || a === "text" || a === "json" ? y.responseText : y.response,
        status: y.status,
        statusText: y.statusText,
        headers: E,
        config: t,
        request: y
      };
      Gr(function(v) {
        n(v), p();
      }, function(v) {
        r(v), p();
      }, b), y = null;
    }
    "onloadend" in y ? y.onloadend = O : y.onreadystatechange = function() {
      !y || y.readyState !== 4 || y.status === 0 && !(y.responseURL && y.responseURL.indexOf("file:") === 0) || setTimeout(O);
    }, y.onabort = function() {
      y && (r(new $("Request aborted", $.ECONNABORTED, t, y)), y = null);
    }, y.onerror = function() {
      r(new $("Network Error", $.ERR_NETWORK, t, y)), y = null;
    }, y.ontimeout = function() {
      let S = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const b = s.transitional || Kr;
      s.timeoutErrorMessage && (S = s.timeoutErrorMessage), r(new $(
        S,
        b.clarifyTimeoutError ? $.ETIMEDOUT : $.ECONNABORTED,
        t,
        y
      )), y = null;
    }, i === void 0 && o.setContentType(null), "setRequestHeader" in y && d.forEach(o.toJSON(), function(S, b) {
      y.setRequestHeader(b, S);
    }), d.isUndefined(s.withCredentials) || (y.withCredentials = !!s.withCredentials), a && a !== "json" && (y.responseType = s.responseType), l && ([m, h] = gt(l, !0), y.addEventListener("progress", m)), c && y.upload && ([u, g] = gt(c), y.upload.addEventListener("progress", u), y.upload.addEventListener("loadend", g)), (s.cancelToken || s.signal) && (f = (E) => {
      y && (r(!E || E.type ? new Ae(null, t, y) : E), y.abort(), y = null);
    }, s.cancelToken && s.cancelToken.subscribe(f), s.signal && (s.signal.aborted ? f() : s.signal.addEventListener("abort", f)));
    const w = Do(s.url);
    if (w && F.protocols.indexOf(w) === -1) {
      r(new $("Unsupported protocol " + w + ":", $.ERR_BAD_REQUEST, t));
      return;
    }
    y.send(i || null);
  });
}, zo = (t, e) => {
  const { length: n } = t = t ? t.filter(Boolean) : [];
  if (e || n) {
    let r = new AbortController(), s;
    const i = function(l) {
      if (!s) {
        s = !0, a();
        const f = l instanceof Error ? l : this.reason;
        r.abort(f instanceof $ ? f : new Ae(f instanceof Error ? f.message : f));
      }
    };
    let o = e && setTimeout(() => {
      o = null, i(new $(`timeout ${e} of ms exceeded`, $.ETIMEDOUT));
    }, e);
    const a = () => {
      t && (o && clearTimeout(o), o = null, t.forEach((l) => {
        l.unsubscribe ? l.unsubscribe(i) : l.removeEventListener("abort", i);
      }), t = null);
    };
    t.forEach((l) => l.addEventListener("abort", i));
    const { signal: c } = r;
    return c.unsubscribe = () => d.asap(a), c;
  }
}, Wo = function* (t, e) {
  let n = t.byteLength;
  if (!e || n < e) {
    yield t;
    return;
  }
  let r = 0, s;
  for (; r < n; )
    s = r + e, yield t.slice(r, s), r = s;
}, Ho = async function* (t, e) {
  for await (const n of Vo(t))
    yield* Wo(n, e);
}, Vo = async function* (t) {
  if (t[Symbol.asyncIterator]) {
    yield* t;
    return;
  }
  const e = t.getReader();
  try {
    for (; ; ) {
      const { done: n, value: r } = await e.read();
      if (n)
        break;
      yield r;
    }
  } finally {
    await e.cancel();
  }
}, dr = (t, e, n, r) => {
  const s = Ho(t, e);
  let i = 0, o, a = (c) => {
    o || (o = !0, r && r(c));
  };
  return new ReadableStream({
    async pull(c) {
      try {
        const { done: l, value: f } = await s.next();
        if (l) {
          a(), c.close();
          return;
        }
        let u = f.byteLength;
        if (n) {
          let m = i += u;
          n(m);
        }
        c.enqueue(new Uint8Array(f));
      } catch (l) {
        throw a(l), l;
      }
    },
    cancel(c) {
      return a(c), s.return();
    }
  }, {
    highWaterMark: 2
  });
}, jt = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", es = jt && typeof ReadableStream == "function", Ko = jt && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((t) => (e) => t.encode(e))(new TextEncoder()) : async (t) => new Uint8Array(await new Response(t).arrayBuffer())), ts = (t, ...e) => {
  try {
    return !!t(...e);
  } catch {
    return !1;
  }
}, Qo = es && ts(() => {
  let t = !1;
  const e = new Request(F.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return t = !0, "half";
    }
  }).headers.has("Content-Type");
  return t && !e;
}), hr = 64 * 1024, An = es && ts(() => d.isReadableStream(new Response("").body)), wt = {
  stream: An && ((t) => t.body)
};
jt && ((t) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((e) => {
    !wt[e] && (wt[e] = d.isFunction(t[e]) ? (n) => n[e]() : (n, r) => {
      throw new $(`Response type '${e}' is not supported`, $.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const Xo = async (t) => {
  if (t == null)
    return 0;
  if (d.isBlob(t))
    return t.size;
  if (d.isSpecCompliantForm(t))
    return (await new Request(F.origin, {
      method: "POST",
      body: t
    }).arrayBuffer()).byteLength;
  if (d.isArrayBufferView(t) || d.isArrayBuffer(t))
    return t.byteLength;
  if (d.isURLSearchParams(t) && (t = t + ""), d.isString(t))
    return (await Ko(t)).byteLength;
}, Go = async (t, e) => {
  const n = d.toFiniteNumber(t.getContentLength());
  return n ?? Xo(e);
}, Yo = jt && (async (t) => {
  let {
    url: e,
    method: n,
    data: r,
    signal: s,
    cancelToken: i,
    timeout: o,
    onDownloadProgress: a,
    onUploadProgress: c,
    responseType: l,
    headers: f,
    withCredentials: u = "same-origin",
    fetchOptions: m
  } = Zr(t);
  l = l ? (l + "").toLowerCase() : "text";
  let g = zo([s, i && i.toAbortSignal()], o), h;
  const p = g && g.unsubscribe && (() => {
    g.unsubscribe();
  });
  let y;
  try {
    if (c && Qo && n !== "get" && n !== "head" && (y = await Go(f, r)) !== 0) {
      let b = new Request(e, {
        method: "POST",
        body: r,
        duplex: "half"
      }), A;
      if (d.isFormData(r) && (A = b.headers.get("content-type")) && f.setContentType(A), b.body) {
        const [v, T] = lr(
          y,
          gt(fr(c))
        );
        r = dr(b.body, hr, v, T);
      }
    }
    d.isString(u) || (u = u ? "include" : "omit");
    const O = "credentials" in Request.prototype;
    h = new Request(e, {
      ...m,
      signal: g,
      method: n.toUpperCase(),
      headers: f.normalize().toJSON(),
      body: r,
      duplex: "half",
      credentials: O ? u : void 0
    });
    let w = await fetch(h);
    const E = An && (l === "stream" || l === "response");
    if (An && (a || E && p)) {
      const b = {};
      ["status", "statusText", "headers"].forEach((D) => {
        b[D] = w[D];
      });
      const A = d.toFiniteNumber(w.headers.get("content-length")), [v, T] = a && lr(
        A,
        gt(fr(a), !0)
      ) || [];
      w = new Response(
        dr(w.body, hr, v, () => {
          T && T(), p && p();
        }),
        b
      );
    }
    l = l || "text";
    let S = await wt[d.findKey(wt, l) || "text"](w, t);
    return !E && p && p(), await new Promise((b, A) => {
      Gr(b, A, {
        data: S,
        headers: M.from(w.headers),
        status: w.status,
        statusText: w.statusText,
        config: t,
        request: h
      });
    });
  } catch (O) {
    throw p && p(), O && O.name === "TypeError" && /fetch/i.test(O.message) ? Object.assign(
      new $("Network Error", $.ERR_NETWORK, t, h),
      {
        cause: O.cause || O
      }
    ) : $.from(O, O && O.code, t, h);
  }
}), $n = {
  http: ho,
  xhr: Jo,
  fetch: Yo
};
d.forEach($n, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const mr = (t) => `- ${t}`, Zo = (t) => d.isFunction(t) || t === null || t === !1, ns = {
  getAdapter: (t) => {
    t = d.isArray(t) ? t : [t];
    const { length: e } = t;
    let n, r;
    const s = {};
    for (let i = 0; i < e; i++) {
      n = t[i];
      let o;
      if (r = n, !Zo(n) && (r = $n[(o = String(n)).toLowerCase()], r === void 0))
        throw new $(`Unknown adapter '${o}'`);
      if (r)
        break;
      s[o || "#" + i] = r;
    }
    if (!r) {
      const i = Object.entries(s).map(
        ([a, c]) => `adapter ${a} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let o = e ? i.length > 1 ? `since :
` + i.map(mr).join(`
`) : " " + mr(i[0]) : "as no adapter specified";
      throw new $(
        "There is no suitable adapter to dispatch the request " + o,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: $n
};
function fn(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new Ae(null, t);
}
function pr(t) {
  return fn(t), t.headers = M.from(t.headers), t.data = ln.call(
    t,
    t.transformRequest
  ), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), ns.getAdapter(t.adapter || xe.adapter)(t).then(function(r) {
    return fn(t), r.data = ln.call(
      t,
      t.transformResponse,
      r
    ), r.headers = M.from(r.headers), r;
  }, function(r) {
    return Xr(r) || (fn(t), r && r.response && (r.response.data = ln.call(
      t,
      t.transformResponse,
      r.response
    ), r.response.headers = M.from(r.response.headers))), Promise.reject(r);
  });
}
const rs = "1.8.2", Mt = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  Mt[t] = function(r) {
    return typeof r === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const yr = {};
Mt.transitional = function(e, n, r) {
  function s(i, o) {
    return "[Axios v" + rs + "] Transitional option '" + i + "'" + o + (r ? ". " + r : "");
  }
  return (i, o, a) => {
    if (e === !1)
      throw new $(
        s(o, " has been removed" + (n ? " in " + n : "")),
        $.ERR_DEPRECATED
      );
    return n && !yr[o] && (yr[o] = !0, console.warn(
      s(
        o,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), e ? e(i, o, a) : !0;
  };
};
Mt.spelling = function(e) {
  return (n, r) => (console.warn(`${r} is likely a misspelling of ${e}`), !0);
};
function ea(t, e, n) {
  if (typeof t != "object")
    throw new $("options must be an object", $.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(t);
  let s = r.length;
  for (; s-- > 0; ) {
    const i = r[s], o = e[i];
    if (o) {
      const a = t[i], c = a === void 0 || o(a, i, t);
      if (c !== !0)
        throw new $("option " + i + " must be " + c, $.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new $("Unknown option " + i, $.ERR_BAD_OPTION);
  }
}
const ht = {
  assertOptions: ea,
  validators: Mt
}, Q = ht.validators;
class ce {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new ar(),
      response: new ar()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, n) {
    try {
      return await this._request(e, n);
    } catch (r) {
      if (r instanceof Error) {
        let s = {};
        Error.captureStackTrace ? Error.captureStackTrace(s) : s = new Error();
        const i = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? i && !String(r.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + i) : r.stack = i;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(e, n) {
    typeof e == "string" ? (n = n || {}, n.url = e) : n = e || {}, n = fe(this.defaults, n);
    const { transitional: r, paramsSerializer: s, headers: i } = n;
    r !== void 0 && ht.assertOptions(r, {
      silentJSONParsing: Q.transitional(Q.boolean),
      forcedJSONParsing: Q.transitional(Q.boolean),
      clarifyTimeoutError: Q.transitional(Q.boolean)
    }, !1), s != null && (d.isFunction(s) ? n.paramsSerializer = {
      serialize: s
    } : ht.assertOptions(s, {
      encode: Q.function,
      serialize: Q.function
    }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), ht.assertOptions(n, {
      baseUrl: Q.spelling("baseURL"),
      withXsrfToken: Q.spelling("withXSRFToken")
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o = i && d.merge(
      i.common,
      i[n.method]
    );
    i && d.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (h) => {
        delete i[h];
      }
    ), n.headers = M.concat(o, i);
    const a = [];
    let c = !0;
    this.interceptors.request.forEach(function(p) {
      typeof p.runWhen == "function" && p.runWhen(n) === !1 || (c = c && p.synchronous, a.unshift(p.fulfilled, p.rejected));
    });
    const l = [];
    this.interceptors.response.forEach(function(p) {
      l.push(p.fulfilled, p.rejected);
    });
    let f, u = 0, m;
    if (!c) {
      const h = [pr.bind(this), void 0];
      for (h.unshift.apply(h, a), h.push.apply(h, l), m = h.length, f = Promise.resolve(n); u < m; )
        f = f.then(h[u++], h[u++]);
      return f;
    }
    m = a.length;
    let g = n;
    for (u = 0; u < m; ) {
      const h = a[u++], p = a[u++];
      try {
        g = h(g);
      } catch (y) {
        p.call(this, y);
        break;
      }
    }
    try {
      f = pr.call(this, g);
    } catch (h) {
      return Promise.reject(h);
    }
    for (u = 0, m = l.length; u < m; )
      f = f.then(l[u++], l[u++]);
    return f;
  }
  getUri(e) {
    e = fe(this.defaults, e);
    const n = Yr(e.baseURL, e.url, e.allowAbsoluteUrls);
    return Vr(n, e.params, e.paramsSerializer);
  }
}
d.forEach(["delete", "get", "head", "options"], function(e) {
  ce.prototype[e] = function(n, r) {
    return this.request(fe(r || {}, {
      method: e,
      url: n,
      data: (r || {}).data
    }));
  };
});
d.forEach(["post", "put", "patch"], function(e) {
  function n(r) {
    return function(i, o, a) {
      return this.request(fe(a || {}, {
        method: e,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: o
      }));
    };
  }
  ce.prototype[e] = n(), ce.prototype[e + "Form"] = n(!0);
});
class Un {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(i) {
      n = i;
    });
    const r = this;
    this.promise.then((s) => {
      if (!r._listeners) return;
      let i = r._listeners.length;
      for (; i-- > 0; )
        r._listeners[i](s);
      r._listeners = null;
    }), this.promise.then = (s) => {
      let i;
      const o = new Promise((a) => {
        r.subscribe(a), i = a;
      }).then(s);
      return o.cancel = function() {
        r.unsubscribe(i);
      }, o;
    }, e(function(i, o, a) {
      r.reason || (r.reason = new Ae(i, o, a), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(e);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), n = (r) => {
      e.abort(r);
    };
    return this.subscribe(n), e.signal.unsubscribe = () => this.unsubscribe(n), e.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new Un(function(s) {
        e = s;
      }),
      cancel: e
    };
  }
}
function ta(t) {
  return function(n) {
    return t.apply(null, n);
  };
}
function na(t) {
  return d.isObject(t) && t.isAxiosError === !0;
}
const vn = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(vn).forEach(([t, e]) => {
  vn[e] = t;
});
function ss(t) {
  const e = new ce(t), n = jr(ce.prototype.request, e);
  return d.extend(n, ce.prototype, e, { allOwnKeys: !0 }), d.extend(n, e, null, { allOwnKeys: !0 }), n.create = function(s) {
    return ss(fe(t, s));
  }, n;
}
const R = ss(xe);
R.Axios = ce;
R.CanceledError = Ae;
R.CancelToken = Un;
R.isCancel = Xr;
R.VERSION = rs;
R.toFormData = Dt;
R.AxiosError = $;
R.Cancel = R.CanceledError;
R.all = function(e) {
  return Promise.all(e);
};
R.spread = ta;
R.isAxiosError = na;
R.mergeConfig = fe;
R.AxiosHeaders = M;
R.formToJSON = (t) => Qr(d.isHTMLForm(t) ? new FormData(t) : t);
R.getAdapter = ns.getAdapter;
R.HttpStatusCode = vn;
R.default = R;
const xn = Symbol.for("yaml.alias"), ra = Symbol.for("yaml.document"), le = Symbol.for("yaml.map"), is = Symbol.for("yaml.pair"), qn = Symbol.for("yaml.scalar"), qe = Symbol.for("yaml.seq"), Z = Symbol.for("yaml.node.type"), $e = (t) => !!t && typeof t == "object" && t[Z] === xn, Bt = (t) => !!t && typeof t == "object" && t[Z] === ra, _t = (t) => !!t && typeof t == "object" && t[Z] === le, P = (t) => !!t && typeof t == "object" && t[Z] === is, N = (t) => !!t && typeof t == "object" && t[Z] === qn, Ut = (t) => !!t && typeof t == "object" && t[Z] === qe;
function j(t) {
  if (t && typeof t == "object")
    switch (t[Z]) {
      case le:
      case qe:
        return !0;
    }
  return !1;
}
function I(t) {
  if (t && typeof t == "object")
    switch (t[Z]) {
      case xn:
      case le:
      case qn:
      case qe:
        return !0;
    }
  return !1;
}
const sa = (t) => (N(t) || j(t)) && !!t.anchor, se = Symbol("break visit"), ia = Symbol("skip children"), Ce = Symbol("remove node");
function ue(t, e) {
  const n = oa(e);
  Bt(t) ? pe(null, t.contents, n, Object.freeze([t])) === Ce && (t.contents = null) : pe(null, t, n, Object.freeze([]));
}
ue.BREAK = se;
ue.SKIP = ia;
ue.REMOVE = Ce;
function pe(t, e, n, r) {
  const s = aa(t, e, n, r);
  if (I(s) || P(s))
    return ca(t, r, s), pe(t, s, n, r);
  if (typeof s != "symbol") {
    if (j(e)) {
      r = Object.freeze(r.concat(e));
      for (let i = 0; i < e.items.length; ++i) {
        const o = pe(i, e.items[i], n, r);
        if (typeof o == "number")
          i = o - 1;
        else {
          if (o === se)
            return se;
          o === Ce && (e.items.splice(i, 1), i -= 1);
        }
      }
    } else if (P(e)) {
      r = Object.freeze(r.concat(e));
      const i = pe("key", e.key, n, r);
      if (i === se)
        return se;
      i === Ce && (e.key = null);
      const o = pe("value", e.value, n, r);
      if (o === se)
        return se;
      o === Ce && (e.value = null);
    }
  }
  return s;
}
function oa(t) {
  return typeof t == "object" && (t.Collection || t.Node || t.Value) ? Object.assign({
    Alias: t.Node,
    Map: t.Node,
    Scalar: t.Node,
    Seq: t.Node
  }, t.Value && {
    Map: t.Value,
    Scalar: t.Value,
    Seq: t.Value
  }, t.Collection && {
    Map: t.Collection,
    Seq: t.Collection
  }, t) : t;
}
function aa(t, e, n, r) {
  if (typeof n == "function")
    return n(t, e, r);
  if (_t(e))
    return n.Map?.(t, e, r);
  if (Ut(e))
    return n.Seq?.(t, e, r);
  if (P(e))
    return n.Pair?.(t, e, r);
  if (N(e))
    return n.Scalar?.(t, e, r);
  if ($e(e))
    return n.Alias?.(t, e, r);
}
function ca(t, e, n) {
  const r = e[e.length - 1];
  if (j(r))
    r.items[t] = n;
  else if (P(r))
    t === "key" ? r.key = n : r.value = n;
  else if (Bt(r))
    r.contents = n;
  else {
    const s = $e(r) ? "alias" : "scalar";
    throw new Error(`Cannot replace node with ${s} parent`);
  }
}
const la = {
  "!": "%21",
  ",": "%2C",
  "[": "%5B",
  "]": "%5D",
  "{": "%7B",
  "}": "%7D"
}, fa = (t) => t.replace(/[!,[\]{}]/g, (e) => la[e]);
class z {
  constructor(e, n) {
    this.docStart = null, this.docEnd = !1, this.yaml = Object.assign({}, z.defaultYaml, e), this.tags = Object.assign({}, z.defaultTags, n);
  }
  clone() {
    const e = new z(this.yaml, this.tags);
    return e.docStart = this.docStart, e;
  }
  /**
   * During parsing, get a Directives instance for the current document and
   * update the stream state according to the current version's spec.
   */
  atDocument() {
    const e = new z(this.yaml, this.tags);
    switch (this.yaml.version) {
      case "1.1":
        this.atNextDocument = !0;
        break;
      case "1.2":
        this.atNextDocument = !1, this.yaml = {
          explicit: z.defaultYaml.explicit,
          version: "1.2"
        }, this.tags = Object.assign({}, z.defaultTags);
        break;
    }
    return e;
  }
  /**
   * @param onError - May be called even if the action was successful
   * @returns `true` on success
   */
  add(e, n) {
    this.atNextDocument && (this.yaml = { explicit: z.defaultYaml.explicit, version: "1.1" }, this.tags = Object.assign({}, z.defaultTags), this.atNextDocument = !1);
    const r = e.trim().split(/[ \t]+/), s = r.shift();
    switch (s) {
      case "%TAG": {
        if (r.length !== 2 && (n(0, "%TAG directive should contain exactly two parts"), r.length < 2))
          return !1;
        const [i, o] = r;
        return this.tags[i] = o, !0;
      }
      case "%YAML": {
        if (this.yaml.explicit = !0, r.length !== 1)
          return n(0, "%YAML directive should contain exactly one part"), !1;
        const [i] = r;
        if (i === "1.1" || i === "1.2")
          return this.yaml.version = i, !0;
        {
          const o = /^\d+\.\d+$/.test(i);
          return n(6, `Unsupported YAML version ${i}`, o), !1;
        }
      }
      default:
        return n(0, `Unknown directive ${s}`, !0), !1;
    }
  }
  /**
   * Resolves a tag, matching handles to those defined in %TAG directives.
   *
   * @returns Resolved tag, which may also be the non-specific tag `'!'` or a
   *   `'!local'` tag, or `null` if unresolvable.
   */
  tagName(e, n) {
    if (e === "!")
      return "!";
    if (e[0] !== "!")
      return n(`Not a valid tag: ${e}`), null;
    if (e[1] === "<") {
      const o = e.slice(2, -1);
      return o === "!" || o === "!!" ? (n(`Verbatim tags aren't resolved, so ${e} is invalid.`), null) : (e[e.length - 1] !== ">" && n("Verbatim tags must end with a >"), o);
    }
    const [, r, s] = e.match(/^(.*!)([^!]*)$/);
    s || n(`The ${e} tag has no suffix`);
    const i = this.tags[r];
    return i ? i + decodeURIComponent(s) : r === "!" ? e : (n(`Could not resolve tag: ${e}`), null);
  }
  /**
   * Given a fully resolved tag, returns its printable string form,
   * taking into account current tag prefixes and defaults.
   */
  tagString(e) {
    for (const [n, r] of Object.entries(this.tags))
      if (e.startsWith(r))
        return n + fa(e.substring(r.length));
    return e[0] === "!" ? e : `!<${e}>`;
  }
  toString(e) {
    const n = this.yaml.explicit ? [`%YAML ${this.yaml.version || "1.2"}`] : [], r = Object.entries(this.tags);
    let s;
    if (e && r.length > 0 && I(e.contents)) {
      const i = {};
      ue(e.contents, (o, a) => {
        I(a) && a.tag && (i[a.tag] = !0);
      }), s = Object.keys(i);
    } else
      s = [];
    for (const [i, o] of r)
      i === "!!" && o === "tag:yaml.org,2002:" || (!e || s.some((a) => a.startsWith(o))) && n.push(`%TAG ${i} ${o}`);
    return n.join(`
`);
  }
}
z.defaultYaml = { explicit: !1, version: "1.2" };
z.defaultTags = { "!!": "tag:yaml.org,2002:" };
function os(t) {
  if (/[\x00-\x19\s,[\]{}]/.test(t)) {
    const n = `Anchor must not contain whitespace or control characters: ${JSON.stringify(t)}`;
    throw new Error(n);
  }
  return !0;
}
function ua(t) {
  const e = /* @__PURE__ */ new Set();
  return ue(t, {
    Value(n, r) {
      r.anchor && e.add(r.anchor);
    }
  }), e;
}
function da(t, e) {
  for (let n = 1; ; ++n) {
    const r = `${t}${n}`;
    if (!e.has(r))
      return r;
  }
}
function Yl(t, e) {
  const n = [], r = /* @__PURE__ */ new Map();
  let s = null;
  return {
    onAnchor: (i) => {
      n.push(i), s || (s = ua(t));
      const o = da(e, s);
      return s.add(o), o;
    },
    /**
     * With circular references, the source node is only resolved after all
     * of its child nodes are. This is why anchors are set only after all of
     * the nodes have been created.
     */
    setAnchors: () => {
      for (const i of n) {
        const o = r.get(i);
        if (typeof o == "object" && o.anchor && (N(o.node) || j(o.node)))
          o.node.anchor = o.anchor;
        else {
          const a = new Error("Failed to resolve repeated object (this should not happen)");
          throw a.source = i, a;
        }
      }
    },
    sourceObjects: r
  };
}
function Re(t, e, n, r) {
  if (r && typeof r == "object")
    if (Array.isArray(r))
      for (let s = 0, i = r.length; s < i; ++s) {
        const o = r[s], a = Re(t, r, String(s), o);
        a === void 0 ? delete r[s] : a !== o && (r[s] = a);
      }
    else if (r instanceof Map)
      for (const s of Array.from(r.keys())) {
        const i = r.get(s), o = Re(t, r, s, i);
        o === void 0 ? r.delete(s) : o !== i && r.set(s, o);
      }
    else if (r instanceof Set)
      for (const s of Array.from(r)) {
        const i = Re(t, r, s, s);
        i === void 0 ? r.delete(s) : i !== s && (r.delete(s), r.add(i));
      }
    else
      for (const [s, i] of Object.entries(r)) {
        const o = Re(t, r, s, i);
        o === void 0 ? delete r[s] : o !== i && (r[s] = o);
      }
  return t.call(e, n, r);
}
function W(t, e, n) {
  if (Array.isArray(t))
    return t.map((r, s) => W(r, String(s), n));
  if (t && typeof t.toJSON == "function") {
    if (!n || !sa(t))
      return t.toJSON(e, n);
    const r = { aliasCount: 0, count: 1, res: void 0 };
    n.anchors.set(t, r), n.onCreate = (i) => {
      r.res = i, delete n.onCreate;
    };
    const s = t.toJSON(e, n);
    return n.onCreate && n.onCreate(s), s;
  }
  return typeof t == "bigint" && !n?.keep ? Number(t) : t;
}
class Jn {
  constructor(e) {
    Object.defineProperty(this, Z, { value: e });
  }
  /** Create a copy of this node.  */
  clone() {
    const e = Object.create(Object.getPrototypeOf(this), Object.getOwnPropertyDescriptors(this));
    return this.range && (e.range = this.range.slice()), e;
  }
  /** A plain JavaScript representation of this node. */
  toJS(e, { mapAsMap: n, maxAliasCount: r, onAnchor: s, reviver: i } = {}) {
    if (!Bt(e))
      throw new TypeError("A document argument is required");
    const o = {
      anchors: /* @__PURE__ */ new Map(),
      doc: e,
      keep: !0,
      mapAsMap: n === !0,
      mapKeyWarned: !1,
      maxAliasCount: typeof r == "number" ? r : 100
    }, a = W(this, "", o);
    if (typeof s == "function")
      for (const { count: c, res: l } of o.anchors.values())
        s(l, c);
    return typeof i == "function" ? Re(i, { "": a }, "", a) : a;
  }
}
class ha extends Jn {
  constructor(e) {
    super(xn), this.source = e, Object.defineProperty(this, "tag", {
      set() {
        throw new Error("Alias nodes cannot have tags");
      }
    });
  }
  /**
   * Resolve the value of this alias within `doc`, finding the last
   * instance of the `source` anchor before this node.
   */
  resolve(e) {
    let n;
    return ue(e, {
      Node: (r, s) => {
        if (s === this)
          return ue.BREAK;
        s.anchor === this.source && (n = s);
      }
    }), n;
  }
  toJSON(e, n) {
    if (!n)
      return { source: this.source };
    const { anchors: r, doc: s, maxAliasCount: i } = n, o = this.resolve(s);
    if (!o) {
      const c = `Unresolved alias (the anchor must be set before the alias): ${this.source}`;
      throw new ReferenceError(c);
    }
    let a = r.get(o);
    if (a || (W(o, null, n), a = r.get(o)), !a || a.res === void 0) {
      const c = "This should not happen: Alias anchor was not resolved?";
      throw new ReferenceError(c);
    }
    if (i >= 0 && (a.count += 1, a.aliasCount === 0 && (a.aliasCount = mt(s, o, r)), a.count * a.aliasCount > i)) {
      const c = "Excessive alias count indicates a resource exhaustion attack";
      throw new ReferenceError(c);
    }
    return a.res;
  }
  toString(e, n, r) {
    const s = `*${this.source}`;
    if (e) {
      if (os(this.source), e.options.verifyAliasOrder && !e.anchors.has(this.source)) {
        const i = `Unresolved alias (the anchor must be set before the alias): ${this.source}`;
        throw new Error(i);
      }
      if (e.implicitKey)
        return `${s} `;
    }
    return s;
  }
}
function mt(t, e, n) {
  if ($e(e)) {
    const r = e.resolve(t), s = n && r && n.get(r);
    return s ? s.count * s.aliasCount : 0;
  } else if (j(e)) {
    let r = 0;
    for (const s of e.items) {
      const i = mt(t, s, n);
      i > r && (r = i);
    }
    return r;
  } else if (P(e)) {
    const r = mt(t, e.key, n), s = mt(t, e.value, n);
    return Math.max(r, s);
  }
  return 1;
}
const as = (t) => !t || typeof t != "function" && typeof t != "object";
class k extends Jn {
  constructor(e) {
    super(qn), this.value = e;
  }
  toJSON(e, n) {
    return n?.keep ? this.value : W(this.value, e, n);
  }
  toString() {
    return String(this.value);
  }
}
k.BLOCK_FOLDED = "BLOCK_FOLDED";
k.BLOCK_LITERAL = "BLOCK_LITERAL";
k.PLAIN = "PLAIN";
k.QUOTE_DOUBLE = "QUOTE_DOUBLE";
k.QUOTE_SINGLE = "QUOTE_SINGLE";
const ma = "tag:yaml.org,2002:";
function pa(t, e, n) {
  if (e) {
    const r = n.filter((i) => i.tag === e), s = r.find((i) => !i.format) ?? r[0];
    if (!s)
      throw new Error(`Tag ${e} not found`);
    return s;
  }
  return n.find((r) => r.identify?.(t) && !r.format);
}
function bt(t, e, n) {
  if (Bt(t) && (t = t.contents), I(t))
    return t;
  if (P(t)) {
    const u = n.schema[le].createNode?.(n.schema, null, n);
    return u.items.push(t), u;
  }
  (t instanceof String || t instanceof Number || t instanceof Boolean || typeof BigInt < "u" && t instanceof BigInt) && (t = t.valueOf());
  const { aliasDuplicateObjects: r, onAnchor: s, onTagObj: i, schema: o, sourceObjects: a } = n;
  let c;
  if (r && t && typeof t == "object") {
    if (c = a.get(t), c)
      return c.anchor || (c.anchor = s(t)), new ha(c.anchor);
    c = { anchor: null, node: null }, a.set(t, c);
  }
  e?.startsWith("!!") && (e = ma + e.slice(2));
  let l = pa(t, e, o.tags);
  if (!l) {
    if (t && typeof t.toJSON == "function" && (t = t.toJSON()), !t || typeof t != "object") {
      const u = new k(t);
      return c && (c.node = u), u;
    }
    l = t instanceof Map ? o[le] : Symbol.iterator in Object(t) ? o[qe] : o[le];
  }
  i && (i(l), delete n.onTagObj);
  const f = l?.createNode ? l.createNode(n.schema, t, n) : typeof l?.nodeClass?.from == "function" ? l.nodeClass.from(n.schema, t, n) : new k(t);
  return e ? f.tag = e : l.default || (f.tag = l.tag), c && (c.node = f), f;
}
function gr(t, e, n) {
  let r = n;
  for (let s = e.length - 1; s >= 0; --s) {
    const i = e[s];
    if (typeof i == "number" && Number.isInteger(i) && i >= 0) {
      const o = [];
      o[i] = r, r = o;
    } else
      r = /* @__PURE__ */ new Map([[i, r]]);
  }
  return bt(r, void 0, {
    aliasDuplicateObjects: !1,
    keepUndefined: !1,
    onAnchor: () => {
      throw new Error("This should not happen, please report a bug.");
    },
    schema: t,
    sourceObjects: /* @__PURE__ */ new Map()
  });
}
const ya = (t) => t == null || typeof t == "object" && !!t[Symbol.iterator]().next().done;
class xt extends Jn {
  constructor(e, n) {
    super(e), Object.defineProperty(this, "schema", {
      value: n,
      configurable: !0,
      enumerable: !1,
      writable: !0
    });
  }
  /**
   * Create a copy of this collection.
   *
   * @param schema - If defined, overwrites the original's schema
   */
  clone(e) {
    const n = Object.create(Object.getPrototypeOf(this), Object.getOwnPropertyDescriptors(this));
    return e && (n.schema = e), n.items = n.items.map((r) => I(r) || P(r) ? r.clone(e) : r), this.range && (n.range = this.range.slice()), n;
  }
  /**
   * Adds a value to the collection. For `!!map` and `!!omap` the value must
   * be a Pair instance or a `{ key, value }` object, which may not have a key
   * that already exists in the map.
   */
  addIn(e, n) {
    if (ya(e))
      this.add(n);
    else {
      const [r, ...s] = e, i = this.get(r, !0);
      if (j(i))
        i.addIn(s, n);
      else if (i === void 0 && this.schema)
        this.set(r, gr(this.schema, s, n));
      else
        throw new Error(`Expected YAML collection at ${r}. Remaining path: ${s}`);
    }
  }
  /**
   * Removes a value from the collection.
   * @returns `true` if the item was found and removed.
   */
  deleteIn(e) {
    const [n, ...r] = e;
    if (r.length === 0)
      return this.delete(n);
    const s = this.get(n, !0);
    if (j(s))
      return s.deleteIn(r);
    throw new Error(`Expected YAML collection at ${n}. Remaining path: ${r}`);
  }
  /**
   * Returns item at `key`, or `undefined` if not found. By default unwraps
   * scalar values from their surrounding node; to disable set `keepScalar` to
   * `true` (collections are always returned intact).
   */
  getIn(e, n) {
    const [r, ...s] = e, i = this.get(r, !0);
    return s.length === 0 ? !n && N(i) ? i.value : i : j(i) ? i.getIn(s, n) : void 0;
  }
  hasAllNullValues(e) {
    return this.items.every((n) => {
      if (!P(n))
        return !1;
      const r = n.value;
      return r == null || e && N(r) && r.value == null && !r.commentBefore && !r.comment && !r.tag;
    });
  }
  /**
   * Checks if the collection includes a value with the key `key`.
   */
  hasIn(e) {
    const [n, ...r] = e;
    if (r.length === 0)
      return this.has(n);
    const s = this.get(n, !0);
    return j(s) ? s.hasIn(r) : !1;
  }
  /**
   * Sets a value in this collection. For `!!set`, `value` needs to be a
   * boolean to add/remove the item from the set.
   */
  setIn(e, n) {
    const [r, ...s] = e;
    if (s.length === 0)
      this.set(r, n);
    else {
      const i = this.get(r, !0);
      if (j(i))
        i.setIn(s, n);
      else if (i === void 0 && this.schema)
        this.set(r, gr(this.schema, s, n));
      else
        throw new Error(`Expected YAML collection at ${r}. Remaining path: ${s}`);
    }
  }
}
xt.maxFlowStringSingleLineLength = 60;
const ga = (t) => t.replace(/^(?!$)(?: $)?/gm, "#");
function De(t, e) {
  return /^\n+$/.test(t) ? t.substring(1) : e ? t.replace(/^(?! *$)/gm, e) : t;
}
const oe = (t, e, n) => t.endsWith(`
`) ? De(n, e) : n.includes(`
`) ? `
` + De(n, e) : (t.endsWith(" ") ? "" : " ") + n, cs = "flow", Tn = "block", pt = "quoted";
function qt(t, e, n = "flow", { indentAtStart: r, lineWidth: s = 80, minContentWidth: i = 20, onFold: o, onOverflow: a } = {}) {
  if (!s || s < 0)
    return t;
  const c = Math.max(1 + i, 1 + s - e.length);
  if (t.length <= c)
    return t;
  const l = [], f = {};
  let u = s - e.length;
  typeof r == "number" && (r > s - Math.max(2, i) ? l.push(0) : u = s - r);
  let m, g, h = !1, p = -1, y = -1, O = -1;
  n === Tn && (p = wr(t, p), p !== -1 && (u = p + c));
  for (let E; E = t[p += 1]; ) {
    if (n === pt && E === "\\") {
      switch (y = p, t[p + 1]) {
        case "x":
          p += 3;
          break;
        case "u":
          p += 5;
          break;
        case "U":
          p += 9;
          break;
        default:
          p += 1;
      }
      O = p;
    }
    if (E === `
`)
      n === Tn && (p = wr(t, p)), u = p + c, m = void 0;
    else {
      if (E === " " && g && g !== " " && g !== `
` && g !== "	") {
        const S = t[p + 1];
        S && S !== " " && S !== `
` && S !== "	" && (m = p);
      }
      if (p >= u)
        if (m)
          l.push(m), u = m + c, m = void 0;
        else if (n === pt) {
          for (; g === " " || g === "	"; )
            g = E, E = t[p += 1], h = !0;
          const S = p > O + 1 ? p - 2 : y - 1;
          if (f[S])
            return t;
          l.push(S), f[S] = !0, u = S + c, m = void 0;
        } else
          h = !0;
    }
    g = E;
  }
  if (h && a && a(), l.length === 0)
    return t;
  o && o();
  let w = t.slice(0, l[0]);
  for (let E = 0; E < l.length; ++E) {
    const S = l[E], b = l[E + 1] || t.length;
    S === 0 ? w = `
${e}${t.slice(0, b)}` : (n === pt && f[S] && (w += `${t[S]}\\`), w += `
${e}${t.slice(S + 1, b)}`);
  }
  return w;
}
function wr(t, e) {
  let n = t[e + 1];
  for (; n === " " || n === "	"; ) {
    do
      n = t[e += 1];
    while (n && n !== `
`);
    n = t[e + 1];
  }
  return e;
}
const Jt = (t, e) => ({
  indentAtStart: e ? t.indent.length : t.indentAtStart,
  lineWidth: t.options.lineWidth,
  minContentWidth: t.options.minContentWidth
}), zt = (t) => /^(%|---|\.\.\.)/m.test(t);
function wa(t, e, n) {
  if (!e || e < 0)
    return !1;
  const r = e - n, s = t.length;
  if (s <= r)
    return !1;
  for (let i = 0, o = 0; i < s; ++i)
    if (t[i] === `
`) {
      if (i - o > r)
        return !0;
      if (o = i + 1, s - o <= r)
        return !1;
    }
  return !0;
}
function Fe(t, e) {
  const n = JSON.stringify(t);
  if (e.options.doubleQuotedAsJSON)
    return n;
  const { implicitKey: r } = e, s = e.options.doubleQuotedMinMultiLineLength, i = e.indent || (zt(t) ? "  " : "");
  let o = "", a = 0;
  for (let c = 0, l = n[c]; l; l = n[++c])
    if (l === " " && n[c + 1] === "\\" && n[c + 2] === "n" && (o += n.slice(a, c) + "\\ ", c += 1, a = c, l = "\\"), l === "\\")
      switch (n[c + 1]) {
        case "u":
          {
            o += n.slice(a, c);
            const f = n.substr(c + 2, 4);
            switch (f) {
              case "0000":
                o += "\\0";
                break;
              case "0007":
                o += "\\a";
                break;
              case "000b":
                o += "\\v";
                break;
              case "001b":
                o += "\\e";
                break;
              case "0085":
                o += "\\N";
                break;
              case "00a0":
                o += "\\_";
                break;
              case "2028":
                o += "\\L";
                break;
              case "2029":
                o += "\\P";
                break;
              default:
                f.substr(0, 2) === "00" ? o += "\\x" + f.substr(2) : o += n.substr(c, 6);
            }
            c += 5, a = c + 1;
          }
          break;
        case "n":
          if (r || n[c + 2] === '"' || n.length < s)
            c += 1;
          else {
            for (o += n.slice(a, c) + `

`; n[c + 2] === "\\" && n[c + 3] === "n" && n[c + 4] !== '"'; )
              o += `
`, c += 2;
            o += i, n[c + 2] === " " && (o += "\\"), c += 1, a = c + 1;
          }
          break;
        default:
          c += 1;
      }
  return o = a ? o + n.slice(a) : n, r ? o : qt(o, i, pt, Jt(e, !1));
}
function kn(t, e) {
  if (e.options.singleQuote === !1 || e.implicitKey && t.includes(`
`) || /[ \t]\n|\n[ \t]/.test(t))
    return Fe(t, e);
  const n = e.indent || (zt(t) ? "  " : ""), r = "'" + t.replace(/'/g, "''").replace(/\n+/g, `$&
${n}`) + "'";
  return e.implicitKey ? r : qt(r, n, cs, Jt(e, !1));
}
function ye(t, e) {
  const { singleQuote: n } = e.options;
  let r;
  if (n === !1)
    r = Fe;
  else {
    const s = t.includes('"'), i = t.includes("'");
    s && !i ? r = kn : i && !s ? r = Fe : r = n ? kn : Fe;
  }
  return r(t, e);
}
let Nn;
try {
  Nn = new RegExp(`(^|(?<!
))
+(?!
|$)`, "g");
} catch {
  Nn = /\n+(?!\n|$)/g;
}
function yt({ comment: t, type: e, value: n }, r, s, i) {
  const { blockQuote: o, commentString: a, lineWidth: c } = r.options;
  if (!o || /\n[\t ]+$/.test(n) || /^\s*$/.test(n))
    return ye(n, r);
  const l = r.indent || (r.forceBlockIndent || zt(n) ? "  " : ""), f = o === "literal" ? !0 : o === "folded" || e === k.BLOCK_FOLDED ? !1 : e === k.BLOCK_LITERAL ? !0 : !wa(n, c, l.length);
  if (!n)
    return f ? `|
` : `>
`;
  let u, m;
  for (m = n.length; m > 0; --m) {
    const A = n[m - 1];
    if (A !== `
` && A !== "	" && A !== " ")
      break;
  }
  let g = n.substring(m);
  const h = g.indexOf(`
`);
  h === -1 ? u = "-" : n === g || h !== g.length - 1 ? (u = "+", i && i()) : u = "", g && (n = n.slice(0, -g.length), g[g.length - 1] === `
` && (g = g.slice(0, -1)), g = g.replace(Nn, `$&${l}`));
  let p = !1, y, O = -1;
  for (y = 0; y < n.length; ++y) {
    const A = n[y];
    if (A === " ")
      p = !0;
    else if (A === `
`)
      O = y;
    else
      break;
  }
  let w = n.substring(0, O < y ? O + 1 : y);
  w && (n = n.substring(w.length), w = w.replace(/\n+/g, `$&${l}`));
  let S = (f ? "|" : ">") + (p ? l ? "2" : "1" : "") + u;
  if (t && (S += " " + a(t.replace(/ ?[\r\n]+/g, " ")), s && s()), f)
    return n = n.replace(/\n+/g, `$&${l}`), `${S}
${l}${w}${n}${g}`;
  n = n.replace(/\n+/g, `
$&`).replace(/(?:^|\n)([\t ].*)(?:([\n\t ]*)\n(?![\n\t ]))?/g, "$1$2").replace(/\n+/g, `$&${l}`);
  const b = qt(`${w}${n}${g}`, l, Tn, Jt(r, !0));
  return `${S}
${l}${b}`;
}
function ba(t, e, n, r) {
  const { type: s, value: i } = t, { actualString: o, implicitKey: a, indent: c, indentStep: l, inFlow: f } = e;
  if (a && i.includes(`
`) || f && /[[\]{},]/.test(i))
    return ye(i, e);
  if (!i || /^[\n\t ,[\]{}#&*!|>'"%@`]|^[?-]$|^[?-][ \t]|[\n:][ \t]|[ \t]\n|[\n\t ]#|[\n\t :]$/.test(i))
    return a || f || !i.includes(`
`) ? ye(i, e) : yt(t, e, n, r);
  if (!a && !f && s !== k.PLAIN && i.includes(`
`))
    return yt(t, e, n, r);
  if (zt(i)) {
    if (c === "")
      return e.forceBlockIndent = !0, yt(t, e, n, r);
    if (a && c === l)
      return ye(i, e);
  }
  const u = i.replace(/\n+/g, `$&
${c}`);
  if (o) {
    const m = (p) => p.default && p.tag !== "tag:yaml.org,2002:str" && p.test?.test(u), { compat: g, tags: h } = e.doc.schema;
    if (h.some(m) || g?.some(m))
      return ye(i, e);
  }
  return a ? u : qt(u, c, cs, Jt(e, !1));
}
function Sa(t, e, n, r) {
  const { implicitKey: s, inFlow: i } = e, o = typeof t.value == "string" ? t : Object.assign({}, t, { value: String(t.value) });
  let { type: a } = t;
  a !== k.QUOTE_DOUBLE && /[\x00-\x08\x0b-\x1f\x7f-\x9f\u{D800}-\u{DFFF}]/u.test(o.value) && (a = k.QUOTE_DOUBLE);
  const c = (f) => {
    switch (f) {
      case k.BLOCK_FOLDED:
      case k.BLOCK_LITERAL:
        return s || i ? ye(o.value, e) : yt(o, e, n, r);
      case k.QUOTE_DOUBLE:
        return Fe(o.value, e);
      case k.QUOTE_SINGLE:
        return kn(o.value, e);
      case k.PLAIN:
        return ba(o, e, n, r);
      default:
        return null;
    }
  };
  let l = c(a);
  if (l === null) {
    const { defaultKeyType: f, defaultStringType: u } = e.options, m = s && f || u;
    if (l = c(m), l === null)
      throw new Error(`Unsupported default string type ${m}`);
  }
  return l;
}
function Ea(t, e) {
  const n = Object.assign({
    blockQuote: !0,
    commentString: ga,
    defaultKeyType: null,
    defaultStringType: "PLAIN",
    directives: null,
    doubleQuotedAsJSON: !1,
    doubleQuotedMinMultiLineLength: 40,
    falseStr: "false",
    flowCollectionPadding: !0,
    indentSeq: !0,
    lineWidth: 80,
    minContentWidth: 20,
    nullStr: "null",
    simpleKeys: !1,
    singleQuote: null,
    trueStr: "true",
    verifyAliasOrder: !0
  }, t.schema.toStringOptions, e);
  let r;
  switch (n.collectionStyle) {
    case "block":
      r = !1;
      break;
    case "flow":
      r = !0;
      break;
    default:
      r = null;
  }
  return {
    anchors: /* @__PURE__ */ new Set(),
    doc: t,
    flowCollectionPadding: n.flowCollectionPadding ? " " : "",
    indent: "",
    indentStep: typeof n.indent == "number" ? " ".repeat(n.indent) : "  ",
    inFlow: r,
    options: n
  };
}
function Oa(t, e) {
  if (e.tag) {
    const s = t.filter((i) => i.tag === e.tag);
    if (s.length > 0)
      return s.find((i) => i.format === e.format) ?? s[0];
  }
  let n, r;
  if (N(e)) {
    r = e.value;
    const s = t.filter((i) => i.identify?.(r));
    n = s.find((i) => i.format === e.format) ?? s.find((i) => !i.format);
  } else
    r = e, n = t.find((s) => s.nodeClass && r instanceof s.nodeClass);
  if (!n) {
    const s = r?.constructor?.name ?? typeof r;
    throw new Error(`Tag not resolved for ${s} value`);
  }
  return n;
}
function Aa(t, e, { anchors: n, doc: r }) {
  if (!r.directives)
    return "";
  const s = [], i = (N(t) || j(t)) && t.anchor;
  i && os(i) && (n.add(i), s.push(`&${i}`));
  const o = t.tag ? t.tag : e.default ? null : e.tag;
  return o && s.push(r.directives.tagString(o)), s.join(" ");
}
function St(t, e, n, r) {
  if (P(t))
    return t.toString(e, n, r);
  if ($e(t)) {
    if (e.doc.directives)
      return t.toString(e);
    if (e.resolvedAliases?.has(t))
      throw new TypeError("Cannot stringify circular structure without alias nodes");
    e.resolvedAliases ? e.resolvedAliases.add(t) : e.resolvedAliases = /* @__PURE__ */ new Set([t]), t = t.resolve(e.doc);
  }
  let s;
  const i = I(t) ? t : e.doc.createNode(t, { onTagObj: (c) => s = c });
  s || (s = Oa(e.doc.schema.tags, i));
  const o = Aa(i, s, e);
  o.length > 0 && (e.indentAtStart = (e.indentAtStart ?? 0) + o.length + 1);
  const a = typeof s.stringify == "function" ? s.stringify(i, e, n, r) : N(i) ? Sa(i, e, n, r) : i.toString(e, n, r);
  return o ? N(i) || a[0] === "{" || a[0] === "[" ? `${o} ${a}` : `${o}
${e.indent}${a}` : a;
}
function $a({ key: t, value: e }, n, r, s) {
  const { allNullValues: i, doc: o, indent: a, indentStep: c, options: { commentString: l, indentSeq: f, simpleKeys: u } } = n;
  let m = I(t) && t.comment || null;
  if (u) {
    if (m)
      throw new Error("With simple keys, key nodes cannot have comments");
    if (j(t)) {
      const v = "With simple keys, collection cannot be used as a key value";
      throw new Error(v);
    }
  }
  let g = !u && (!t || m && e == null && !n.inFlow || j(t) || (N(t) ? t.type === k.BLOCK_FOLDED || t.type === k.BLOCK_LITERAL : typeof t == "object"));
  n = Object.assign({}, n, {
    allNullValues: !1,
    implicitKey: !g && (u || !i),
    indent: a + c
  });
  let h = !1, p = !1, y = St(t, n, () => h = !0, () => p = !0);
  if (!g && !n.inFlow && y.length > 1024) {
    if (u)
      throw new Error("With simple keys, single line scalar must not span more than 1024 characters");
    g = !0;
  }
  if (n.inFlow) {
    if (i || e == null)
      return h && r && r(), y === "" ? "?" : g ? `? ${y}` : y;
  } else if (i && !u || e == null && g)
    return y = `? ${y}`, m && !h ? y += oe(y, n.indent, l(m)) : p && s && s(), y;
  h && (m = null), g ? (m && (y += oe(y, n.indent, l(m))), y = `? ${y}
${a}:`) : (y = `${y}:`, m && (y += oe(y, n.indent, l(m))));
  let O, w, E;
  I(e) ? (O = !!e.spaceBefore, w = e.commentBefore, E = e.comment) : (O = !1, w = null, E = null, e && typeof e == "object" && (e = o.createNode(e))), n.implicitKey = !1, !g && !m && N(e) && (n.indentAtStart = y.length + 1), p = !1, !f && c.length >= 2 && !n.inFlow && !g && Ut(e) && !e.flow && !e.tag && !e.anchor && (n.indent = n.indent.substring(2));
  let S = !1;
  const b = St(e, n, () => S = !0, () => p = !0);
  let A = " ";
  if (m || O || w) {
    if (A = O ? `
` : "", w) {
      const v = l(w);
      A += `
${De(v, n.indent)}`;
    }
    b === "" && !n.inFlow ? A === `
` && (A = `

`) : A += `
${n.indent}`;
  } else if (!g && j(e)) {
    const v = b[0], T = b.indexOf(`
`), D = T !== -1, ke = n.inFlow ?? e.flow ?? e.items.length === 0;
    if (D || !ke) {
      let he = !1;
      if (D && (v === "&" || v === "!")) {
        let te = b.indexOf(" ");
        v === "&" && te !== -1 && te < T && b[te + 1] === "!" && (te = b.indexOf(" ", te + 1)), (te === -1 || T < te) && (he = !0);
      }
      he || (A = `
${n.indent}`);
    }
  } else (b === "" || b[0] === `
`) && (A = "");
  return y += A + b, n.inFlow ? S && r && r() : E && !S ? y += oe(y, n.indent, l(E)) : p && s && s(), y;
}
function va(t, e) {
  (t === "debug" || t === "warn") && (typeof G < "u" && G.emitWarning ? G.emitWarning(e) : console.warn(e));
}
const br = "<<";
function ls(t, e, { key: n, value: r }) {
  if (t?.doc.schema.merge && Ta(n))
    if (r = $e(r) ? r.resolve(t.doc) : r, Ut(r))
      for (const s of r.items)
        un(t, e, s);
    else if (Array.isArray(r))
      for (const s of r)
        un(t, e, s);
    else
      un(t, e, r);
  else {
    const s = W(n, "", t);
    if (e instanceof Map)
      e.set(s, W(r, s, t));
    else if (e instanceof Set)
      e.add(s);
    else {
      const i = ka(n, s, t), o = W(r, i, t);
      i in e ? Object.defineProperty(e, i, {
        value: o,
        writable: !0,
        enumerable: !0,
        configurable: !0
      }) : e[i] = o;
    }
  }
  return e;
}
const Ta = (t) => t === br || N(t) && t.value === br && (!t.type || t.type === k.PLAIN);
function un(t, e, n) {
  const r = t && $e(n) ? n.resolve(t.doc) : n;
  if (!_t(r))
    throw new Error("Merge sources must be maps or map aliases");
  const s = r.toJSON(null, t, Map);
  for (const [i, o] of s)
    e instanceof Map ? e.has(i) || e.set(i, o) : e instanceof Set ? e.add(i) : Object.prototype.hasOwnProperty.call(e, i) || Object.defineProperty(e, i, {
      value: o,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  return e;
}
function ka(t, e, n) {
  if (e === null)
    return "";
  if (typeof e != "object")
    return String(e);
  if (I(t) && n?.doc) {
    const r = Ea(n.doc, {});
    r.anchors = /* @__PURE__ */ new Set();
    for (const i of n.anchors.keys())
      r.anchors.add(i.anchor);
    r.inFlow = !0, r.inStringifyKey = !0;
    const s = t.toString(r);
    if (!n.mapKeyWarned) {
      let i = JSON.stringify(s);
      i.length > 40 && (i = i.substring(0, 36) + '..."'), va(n.doc.options.logLevel, `Keys with collection values will be stringified due to JS Object restrictions: ${i}. Set mapAsMap: true to use object keys.`), n.mapKeyWarned = !0;
    }
    return s;
  }
  return JSON.stringify(e);
}
function zn(t, e, n) {
  const r = bt(t, void 0, n), s = bt(e, void 0, n);
  return new H(r, s);
}
class H {
  constructor(e, n = null) {
    Object.defineProperty(this, Z, { value: is }), this.key = e, this.value = n;
  }
  clone(e) {
    let { key: n, value: r } = this;
    return I(n) && (n = n.clone(e)), I(r) && (r = r.clone(e)), new H(n, r);
  }
  toJSON(e, n) {
    const r = n?.mapAsMap ? /* @__PURE__ */ new Map() : {};
    return ls(n, r, this);
  }
  toString(e, n, r) {
    return e?.doc ? $a(this, e, n, r) : JSON.stringify(this);
  }
}
function fs(t, e, n) {
  return (e.inFlow ?? t.flow ? Ra : Na)(t, e, n);
}
function Na({ comment: t, items: e }, n, { blockItemPrefix: r, flowChars: s, itemIndent: i, onChompKeep: o, onComment: a }) {
  const { indent: c, options: { commentString: l } } = n, f = Object.assign({}, n, { indent: i, type: null });
  let u = !1;
  const m = [];
  for (let h = 0; h < e.length; ++h) {
    const p = e[h];
    let y = null;
    if (I(p))
      !u && p.spaceBefore && m.push(""), Et(n, m, p.commentBefore, u), p.comment && (y = p.comment);
    else if (P(p)) {
      const w = I(p.key) ? p.key : null;
      w && (!u && w.spaceBefore && m.push(""), Et(n, m, w.commentBefore, u));
    }
    u = !1;
    let O = St(p, f, () => y = null, () => u = !0);
    y && (O += oe(O, i, l(y))), u && y && (u = !1), m.push(r + O);
  }
  let g;
  if (m.length === 0)
    g = s.start + s.end;
  else {
    g = m[0];
    for (let h = 1; h < m.length; ++h) {
      const p = m[h];
      g += p ? `
${c}${p}` : `
`;
    }
  }
  return t ? (g += `
` + De(l(t), c), a && a()) : u && o && o(), g;
}
function Ra({ comment: t, items: e }, n, { flowChars: r, itemIndent: s, onComment: i }) {
  const { indent: o, indentStep: a, flowCollectionPadding: c, options: { commentString: l } } = n;
  s += a;
  const f = Object.assign({}, n, {
    indent: s,
    inFlow: !0,
    type: null
  });
  let u = !1, m = 0;
  const g = [];
  for (let O = 0; O < e.length; ++O) {
    const w = e[O];
    let E = null;
    if (I(w))
      w.spaceBefore && g.push(""), Et(n, g, w.commentBefore, !1), w.comment && (E = w.comment);
    else if (P(w)) {
      const b = I(w.key) ? w.key : null;
      b && (b.spaceBefore && g.push(""), Et(n, g, b.commentBefore, !1), b.comment && (u = !0));
      const A = I(w.value) ? w.value : null;
      A ? (A.comment && (E = A.comment), A.commentBefore && (u = !0)) : w.value == null && b?.comment && (E = b.comment);
    }
    E && (u = !0);
    let S = St(w, f, () => E = null);
    O < e.length - 1 && (S += ","), E && (S += oe(S, s, l(E))), !u && (g.length > m || S.includes(`
`)) && (u = !0), g.push(S), m = g.length;
  }
  let h;
  const { start: p, end: y } = r;
  if (g.length === 0)
    h = p + y;
  else if (u || (u = g.reduce((w, E) => w + E.length + 2, 2) > xt.maxFlowStringSingleLineLength), u) {
    h = p;
    for (const O of g)
      h += O ? `
${a}${o}${O}` : `
`;
    h += `
${o}${y}`;
  } else
    h = `${p}${c}${g.join(" ")}${c}${y}`;
  return t && (h += oe(h, o, l(t)), i && i()), h;
}
function Et({ indent: t, options: { commentString: e } }, n, r, s) {
  if (r && s && (r = r.replace(/^\n+/, "")), r) {
    const i = De(e(r), t);
    n.push(i.trimStart());
  }
}
function ae(t, e) {
  const n = N(e) ? e.value : e;
  for (const r of t)
    if (P(r) && (r.key === e || r.key === n || N(r.key) && r.key.value === n))
      return r;
}
class me extends xt {
  static get tagName() {
    return "tag:yaml.org,2002:map";
  }
  constructor(e) {
    super(le, e), this.items = [];
  }
  /**
   * A generic collection parsing method that can be extended
   * to other node classes that inherit from YAMLMap
   */
  static from(e, n, r) {
    const { keepUndefined: s, replacer: i } = r, o = new this(e), a = (c, l) => {
      if (typeof i == "function")
        l = i.call(n, c, l);
      else if (Array.isArray(i) && !i.includes(c))
        return;
      (l !== void 0 || s) && o.items.push(zn(c, l, r));
    };
    if (n instanceof Map)
      for (const [c, l] of n)
        a(c, l);
    else if (n && typeof n == "object")
      for (const c of Object.keys(n))
        a(c, n[c]);
    return typeof e.sortMapEntries == "function" && o.items.sort(e.sortMapEntries), o;
  }
  /**
   * Adds a value to the collection.
   *
   * @param overwrite - If not set `true`, using a key that is already in the
   *   collection will throw. Otherwise, overwrites the previous value.
   */
  add(e, n) {
    let r;
    P(e) ? r = e : !e || typeof e != "object" || !("key" in e) ? r = new H(e, e?.value) : r = new H(e.key, e.value);
    const s = ae(this.items, r.key), i = this.schema?.sortMapEntries;
    if (s) {
      if (!n)
        throw new Error(`Key ${r.key} already set`);
      N(s.value) && as(r.value) ? s.value.value = r.value : s.value = r.value;
    } else if (i) {
      const o = this.items.findIndex((a) => i(r, a) < 0);
      o === -1 ? this.items.push(r) : this.items.splice(o, 0, r);
    } else
      this.items.push(r);
  }
  delete(e) {
    const n = ae(this.items, e);
    return n ? this.items.splice(this.items.indexOf(n), 1).length > 0 : !1;
  }
  get(e, n) {
    const s = ae(this.items, e)?.value;
    return (!n && N(s) ? s.value : s) ?? void 0;
  }
  has(e) {
    return !!ae(this.items, e);
  }
  set(e, n) {
    this.add(new H(e, n), !0);
  }
  /**
   * @param ctx - Conversion context, originally set in Document#toJS()
   * @param {Class} Type - If set, forces the returned collection type
   * @returns Instance of Type, Map, or Object
   */
  toJSON(e, n, r) {
    const s = r ? new r() : n?.mapAsMap ? /* @__PURE__ */ new Map() : {};
    n?.onCreate && n.onCreate(s);
    for (const i of this.items)
      ls(n, s, i);
    return s;
  }
  toString(e, n, r) {
    if (!e)
      return JSON.stringify(this);
    for (const s of this.items)
      if (!P(s))
        throw new Error(`Map items must all be pairs; found ${JSON.stringify(s)} instead`);
    return !e.allNullValues && this.hasAllNullValues(!1) && (e = Object.assign({}, e, { allNullValues: !0 })), fs(this, e, {
      blockItemPrefix: "",
      flowChars: { start: "{", end: "}" },
      itemIndent: e.indent || "",
      onChompKeep: r,
      onComment: n
    });
  }
}
class us extends xt {
  static get tagName() {
    return "tag:yaml.org,2002:seq";
  }
  constructor(e) {
    super(qe, e), this.items = [];
  }
  add(e) {
    this.items.push(e);
  }
  /**
   * Removes a value from the collection.
   *
   * `key` must contain a representation of an integer for this to succeed.
   * It may be wrapped in a `Scalar`.
   *
   * @returns `true` if the item was found and removed.
   */
  delete(e) {
    const n = He(e);
    return typeof n != "number" ? !1 : this.items.splice(n, 1).length > 0;
  }
  get(e, n) {
    const r = He(e);
    if (typeof r != "number")
      return;
    const s = this.items[r];
    return !n && N(s) ? s.value : s;
  }
  /**
   * Checks if the collection includes a value with the key `key`.
   *
   * `key` must contain a representation of an integer for this to succeed.
   * It may be wrapped in a `Scalar`.
   */
  has(e) {
    const n = He(e);
    return typeof n == "number" && n < this.items.length;
  }
  /**
   * Sets a value in this collection. For `!!set`, `value` needs to be a
   * boolean to add/remove the item from the set.
   *
   * If `key` does not contain a representation of an integer, this will throw.
   * It may be wrapped in a `Scalar`.
   */
  set(e, n) {
    const r = He(e);
    if (typeof r != "number")
      throw new Error(`Expected a valid index, not ${e}.`);
    const s = this.items[r];
    N(s) && as(n) ? s.value = n : this.items[r] = n;
  }
  toJSON(e, n) {
    const r = [];
    n?.onCreate && n.onCreate(r);
    let s = 0;
    for (const i of this.items)
      r.push(W(i, String(s++), n));
    return r;
  }
  toString(e, n, r) {
    return e ? fs(this, e, {
      blockItemPrefix: "- ",
      flowChars: { start: "[", end: "]" },
      itemIndent: (e.indent || "") + "  ",
      onChompKeep: r,
      onComment: n
    }) : JSON.stringify(this);
  }
  static from(e, n, r) {
    const { replacer: s } = r, i = new this(e);
    if (n && Symbol.iterator in Object(n)) {
      let o = 0;
      for (let a of n) {
        if (typeof s == "function") {
          const c = n instanceof Set ? a : String(o++);
          a = s.call(n, c, a);
        }
        i.items.push(bt(a, void 0, r));
      }
    }
    return i;
  }
}
function He(t) {
  let e = N(t) ? t.value : t;
  return e && typeof e == "string" && (e = Number(e)), typeof e == "number" && Number.isInteger(e) && e >= 0 ? e : null;
}
function ds(t, e) {
  if (Ut(t))
    for (let n = 0; n < t.items.length; ++n) {
      let r = t.items[n];
      if (!P(r)) {
        if (_t(r)) {
          r.items.length > 1 && e("Each pair must have its own sequence indicator");
          const s = r.items[0] || new H(new k(null));
          if (r.commentBefore && (s.key.commentBefore = s.key.commentBefore ? `${r.commentBefore}
${s.key.commentBefore}` : r.commentBefore), r.comment) {
            const i = s.value ?? s.key;
            i.comment = i.comment ? `${r.comment}
${i.comment}` : r.comment;
          }
          r = s;
        }
        t.items[n] = P(r) ? r : new H(r);
      }
    }
  else
    e("Expected a sequence for this tag");
  return t;
}
function hs(t, e, n) {
  const { replacer: r } = n, s = new us(t);
  s.tag = "tag:yaml.org,2002:pairs";
  let i = 0;
  if (e && Symbol.iterator in Object(e))
    for (let o of e) {
      typeof r == "function" && (o = r.call(e, String(i++), o));
      let a, c;
      if (Array.isArray(o))
        if (o.length === 2)
          a = o[0], c = o[1];
        else
          throw new TypeError(`Expected [key, value] tuple: ${o}`);
      else if (o && o instanceof Object) {
        const l = Object.keys(o);
        if (l.length === 1)
          a = l[0], c = o[a];
        else
          throw new TypeError(`Expected tuple with one key, not ${l.length} keys`);
      } else
        a = o;
      s.items.push(zn(a, c, n));
    }
  return s;
}
const Zl = {
  collection: "seq",
  default: !1,
  tag: "tag:yaml.org,2002:pairs",
  resolve: ds,
  createNode: hs
};
class ge extends us {
  constructor() {
    super(), this.add = me.prototype.add.bind(this), this.delete = me.prototype.delete.bind(this), this.get = me.prototype.get.bind(this), this.has = me.prototype.has.bind(this), this.set = me.prototype.set.bind(this), this.tag = ge.tag;
  }
  /**
   * If `ctx` is given, the return type is actually `Map<unknown, unknown>`,
   * but TypeScript won't allow widening the signature of a child method.
   */
  toJSON(e, n) {
    if (!n)
      return super.toJSON(e);
    const r = /* @__PURE__ */ new Map();
    n?.onCreate && n.onCreate(r);
    for (const s of this.items) {
      let i, o;
      if (P(s) ? (i = W(s.key, "", n), o = W(s.value, i, n)) : i = W(s, "", n), r.has(i))
        throw new Error("Ordered maps must not include duplicate keys");
      r.set(i, o);
    }
    return r;
  }
  static from(e, n, r) {
    const s = hs(e, n, r), i = new this();
    return i.items = s.items, i;
  }
}
ge.tag = "tag:yaml.org,2002:omap";
const ef = {
  collection: "seq",
  identify: (t) => t instanceof Map,
  nodeClass: ge,
  default: !1,
  tag: "tag:yaml.org,2002:omap",
  resolve(t, e) {
    const n = ds(t, e), r = [];
    for (const { key: s } of n.items)
      N(s) && (r.includes(s.value) ? e(`Ordered maps must not include duplicate keys: ${s.value}`) : r.push(s.value));
    return Object.assign(new ge(), n);
  },
  createNode: (t, e, n) => ge.from(t, e, n)
};
class we extends me {
  constructor(e) {
    super(e), this.tag = we.tag;
  }
  add(e) {
    let n;
    P(e) ? n = e : e && typeof e == "object" && "key" in e && "value" in e && e.value === null ? n = new H(e.key, null) : n = new H(e, null), ae(this.items, n.key) || this.items.push(n);
  }
  /**
   * If `keepPair` is `true`, returns the Pair matching `key`.
   * Otherwise, returns the value of that Pair's key.
   */
  get(e, n) {
    const r = ae(this.items, e);
    return !n && P(r) ? N(r.key) ? r.key.value : r.key : r;
  }
  set(e, n) {
    if (typeof n != "boolean")
      throw new Error(`Expected boolean value for set(key, value) in a YAML set, not ${typeof n}`);
    const r = ae(this.items, e);
    r && !n ? this.items.splice(this.items.indexOf(r), 1) : !r && n && this.items.push(new H(e));
  }
  toJSON(e, n) {
    return super.toJSON(e, n, Set);
  }
  toString(e, n, r) {
    if (!e)
      return JSON.stringify(this);
    if (this.hasAllNullValues(!0))
      return super.toString(Object.assign({}, e, { allNullValues: !0 }), n, r);
    throw new Error("Set items must all have null values");
  }
  static from(e, n, r) {
    const { replacer: s } = r, i = new this(e);
    if (n && Symbol.iterator in Object(n))
      for (let o of n)
        typeof s == "function" && (o = s.call(n, o, o)), i.items.push(zn(o, null, r));
    return i;
  }
}
we.tag = "tag:yaml.org,2002:set";
const tf = {
  collection: "map",
  identify: (t) => t instanceof Set,
  nodeClass: we,
  default: !1,
  tag: "tag:yaml.org,2002:set",
  createNode: (t, e, n) => we.from(t, e, n),
  resolve(t, e) {
    if (_t(t)) {
      if (t.hasAllNullValues(!0))
        return Object.assign(new we(), t);
      e("Set items must all have null values");
    } else
      e("Expected a mapping for this tag");
    return t;
  }
};
function X(t) {
  if (typeof t != "string")
    throw new TypeError("Path must be a string. Received " + JSON.stringify(t));
}
function Sr(t, e) {
  for (var n = "", r = 0, s = -1, i = 0, o, a = 0; a <= t.length; ++a) {
    if (a < t.length)
      o = t.charCodeAt(a);
    else {
      if (o === 47)
        break;
      o = 47;
    }
    if (o === 47) {
      if (!(s === a - 1 || i === 1)) if (s !== a - 1 && i === 2) {
        if (n.length < 2 || r !== 2 || n.charCodeAt(n.length - 1) !== 46 || n.charCodeAt(n.length - 2) !== 46) {
          if (n.length > 2) {
            var c = n.lastIndexOf("/");
            if (c !== n.length - 1) {
              c === -1 ? (n = "", r = 0) : (n = n.slice(0, c), r = n.length - 1 - n.lastIndexOf("/")), s = a, i = 0;
              continue;
            }
          } else if (n.length === 2 || n.length === 1) {
            n = "", r = 0, s = a, i = 0;
            continue;
          }
        }
        e && (n.length > 0 ? n += "/.." : n = "..", r = 2);
      } else
        n.length > 0 ? n += "/" + t.slice(s + 1, a) : n = t.slice(s + 1, a), r = a - s - 1;
      s = a, i = 0;
    } else o === 46 && i !== -1 ? ++i : i = -1;
  }
  return n;
}
function Pa(t, e) {
  var n = e.dir || e.root, r = e.base || (e.name || "") + (e.ext || "");
  return n ? n === e.root ? n + r : n + t + r : r;
}
var be = {
  // path.resolve([from ...], to)
  resolve: function() {
    for (var e = "", n = !1, r, s = arguments.length - 1; s >= -1 && !n; s--) {
      var i;
      s >= 0 ? i = arguments[s] : (r === void 0 && (r = G.cwd()), i = r), X(i), i.length !== 0 && (e = i + "/" + e, n = i.charCodeAt(0) === 47);
    }
    return e = Sr(e, !n), n ? e.length > 0 ? "/" + e : "/" : e.length > 0 ? e : ".";
  },
  normalize: function(e) {
    if (X(e), e.length === 0) return ".";
    var n = e.charCodeAt(0) === 47, r = e.charCodeAt(e.length - 1) === 47;
    return e = Sr(e, !n), e.length === 0 && !n && (e = "."), e.length > 0 && r && (e += "/"), n ? "/" + e : e;
  },
  isAbsolute: function(e) {
    return X(e), e.length > 0 && e.charCodeAt(0) === 47;
  },
  join: function() {
    if (arguments.length === 0)
      return ".";
    for (var e, n = 0; n < arguments.length; ++n) {
      var r = arguments[n];
      X(r), r.length > 0 && (e === void 0 ? e = r : e += "/" + r);
    }
    return e === void 0 ? "." : be.normalize(e);
  },
  relative: function(e, n) {
    if (X(e), X(n), e === n || (e = be.resolve(e), n = be.resolve(n), e === n)) return "";
    for (var r = 1; r < e.length && e.charCodeAt(r) === 47; ++r)
      ;
    for (var s = e.length, i = s - r, o = 1; o < n.length && n.charCodeAt(o) === 47; ++o)
      ;
    for (var a = n.length, c = a - o, l = i < c ? i : c, f = -1, u = 0; u <= l; ++u) {
      if (u === l) {
        if (c > l) {
          if (n.charCodeAt(o + u) === 47)
            return n.slice(o + u + 1);
          if (u === 0)
            return n.slice(o + u);
        } else i > l && (e.charCodeAt(r + u) === 47 ? f = u : u === 0 && (f = 0));
        break;
      }
      var m = e.charCodeAt(r + u), g = n.charCodeAt(o + u);
      if (m !== g)
        break;
      m === 47 && (f = u);
    }
    var h = "";
    for (u = r + f + 1; u <= s; ++u)
      (u === s || e.charCodeAt(u) === 47) && (h.length === 0 ? h += ".." : h += "/..");
    return h.length > 0 ? h + n.slice(o + f) : (o += f, n.charCodeAt(o) === 47 && ++o, n.slice(o));
  },
  _makeLong: function(e) {
    return e;
  },
  dirname: function(e) {
    if (X(e), e.length === 0) return ".";
    for (var n = e.charCodeAt(0), r = n === 47, s = -1, i = !0, o = e.length - 1; o >= 1; --o)
      if (n = e.charCodeAt(o), n === 47) {
        if (!i) {
          s = o;
          break;
        }
      } else
        i = !1;
    return s === -1 ? r ? "/" : "." : r && s === 1 ? "//" : e.slice(0, s);
  },
  basename: function(e, n) {
    if (n !== void 0 && typeof n != "string") throw new TypeError('"ext" argument must be a string');
    X(e);
    var r = 0, s = -1, i = !0, o;
    if (n !== void 0 && n.length > 0 && n.length <= e.length) {
      if (n.length === e.length && n === e) return "";
      var a = n.length - 1, c = -1;
      for (o = e.length - 1; o >= 0; --o) {
        var l = e.charCodeAt(o);
        if (l === 47) {
          if (!i) {
            r = o + 1;
            break;
          }
        } else
          c === -1 && (i = !1, c = o + 1), a >= 0 && (l === n.charCodeAt(a) ? --a === -1 && (s = o) : (a = -1, s = c));
      }
      return r === s ? s = c : s === -1 && (s = e.length), e.slice(r, s);
    } else {
      for (o = e.length - 1; o >= 0; --o)
        if (e.charCodeAt(o) === 47) {
          if (!i) {
            r = o + 1;
            break;
          }
        } else s === -1 && (i = !1, s = o + 1);
      return s === -1 ? "" : e.slice(r, s);
    }
  },
  extname: function(e) {
    X(e);
    for (var n = -1, r = 0, s = -1, i = !0, o = 0, a = e.length - 1; a >= 0; --a) {
      var c = e.charCodeAt(a);
      if (c === 47) {
        if (!i) {
          r = a + 1;
          break;
        }
        continue;
      }
      s === -1 && (i = !1, s = a + 1), c === 46 ? n === -1 ? n = a : o !== 1 && (o = 1) : n !== -1 && (o = -1);
    }
    return n === -1 || s === -1 || // We saw a non-dot character immediately before the dot
    o === 0 || // The (right-most) trimmed path component is exactly '..'
    o === 1 && n === s - 1 && n === r + 1 ? "" : e.slice(n, s);
  },
  format: function(e) {
    if (e === null || typeof e != "object")
      throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof e);
    return Pa("/", e);
  },
  parse: function(e) {
    X(e);
    var n = { root: "", dir: "", base: "", ext: "", name: "" };
    if (e.length === 0) return n;
    var r = e.charCodeAt(0), s = r === 47, i;
    s ? (n.root = "/", i = 1) : i = 0;
    for (var o = -1, a = 0, c = -1, l = !0, f = e.length - 1, u = 0; f >= i; --f) {
      if (r = e.charCodeAt(f), r === 47) {
        if (!l) {
          a = f + 1;
          break;
        }
        continue;
      }
      c === -1 && (l = !1, c = f + 1), r === 46 ? o === -1 ? o = f : u !== 1 && (u = 1) : o !== -1 && (u = -1);
    }
    return o === -1 || c === -1 || // We saw a non-dot character immediately before the dot
    u === 0 || // The (right-most) trimmed path component is exactly '..'
    u === 1 && o === c - 1 && o === a + 1 ? c !== -1 && (a === 0 && s ? n.base = n.name = e.slice(1, c) : n.base = n.name = e.slice(a, c)) : (a === 0 && s ? (n.name = e.slice(1, o), n.base = e.slice(1, c)) : (n.name = e.slice(a, o), n.base = e.slice(a, c)), n.ext = e.slice(o, c)), a > 0 ? n.dir = e.slice(0, a - 1) : s && (n.dir = "/"), n;
  },
  sep: "/",
  delimiter: ":",
  win32: null,
  posix: null
};
be.posix = be;
var x = be;
const nf = /* @__PURE__ */ Dr(x);
var Wt = {}, Ca = null;
const Fa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ca
}, Symbol.toStringTag, { value: "Module" })), Wn = /* @__PURE__ */ $i(Fa);
var Ia = (t) => function() {
  const e = arguments.length, n = new Array(e);
  for (let r = 0; r < e; r += 1)
    n[r] = arguments[r];
  return new Promise((r, s) => {
    n.push((i, o) => {
      i ? s(i) : r(o);
    }), t.apply(null, n);
  });
};
const Ot = Wn, La = Ia, Da = (t) => [
  typeof Ot[t] == "function",
  !t.match(/Sync$/),
  !t.match(/^[A-Z]/),
  !t.match(/^create/),
  !t.match(/^(un)?watch/)
].every(Boolean), ja = (t) => {
  const e = Ot[t];
  return La(e);
}, Ma = () => {
  const t = {};
  return Object.keys(Ot).forEach((e) => {
    Da(e) ? e === "exists" ? t.exists = () => {
      throw new Error("fs.exists() is deprecated");
    } : t[e] = ja(e) : t[e] = Ot[e];
  }), t;
};
var q = Ma(), de = {};
const Ba = (t) => {
  const e = (n) => ["a", "e", "i", "o", "u"].indexOf(n[0]) !== -1 ? `an ${n}` : `a ${n}`;
  return t.map(e).join(" or ");
}, ms = (t) => /array of /.test(t), ps = (t) => t.split(" of ")[1], ys = (t) => ms(t) ? ys(ps(t)) : [
  "string",
  "number",
  "boolean",
  "array",
  "object",
  "buffer",
  "null",
  "undefined",
  "function"
].some((e) => e === t), je = (t) => t === null ? "null" : Array.isArray(t) ? "array" : Dn.isBuffer(t) ? "buffer" : typeof t, _a = (t, e, n) => n.indexOf(t) === e, Ua = (t) => {
  let e = je(t), n;
  return e === "array" && (n = t.map((r) => je(r)).filter(_a), e += ` of ${n.join(", ")}`), e;
}, xa = (t, e) => {
  const n = ps(e);
  return je(t) !== "array" ? !1 : t.every((r) => je(r) === n);
}, Rn = (t, e, n, r) => {
  if (!r.some((i) => {
    if (!ys(i))
      throw new Error(`Unknown type "${i}"`);
    return ms(i) ? xa(n, i) : i === je(n);
  }))
    throw new Error(
      `Argument "${e}" passed to ${t} must be ${Ba(
        r
      )}. Received ${Ua(n)}`
    );
}, qa = (t, e, n, r) => {
  n !== void 0 && (Rn(t, e, n, ["object"]), Object.keys(n).forEach((s) => {
    const i = `${e}.${s}`;
    if (r[s] !== void 0)
      Rn(t, i, n[s], r[s]);
    else
      throw new Error(
        `Unknown argument "${i}" passed to ${t}`
      );
  }));
};
var L = {
  argument: Rn,
  options: qa
}, K = {}, Ht = {};
Ht.normalizeFileMode = (t) => {
  let e;
  return typeof t == "number" ? e = t.toString(8) : e = t, e.substring(e.length - 3);
};
var ve = {};
const gs = q, Ja = L, za = (t, e) => {
  const n = `${t}([path])`;
  Ja.argument(n, "path", e, ["string", "undefined"]);
}, Wa = (t) => {
  gs.rmSync(t, {
    recursive: !0,
    force: !0,
    maxRetries: 3
  });
}, Ha = (t) => gs.rm(t, {
  recursive: !0,
  force: !0,
  maxRetries: 3
});
ve.validateInput = za;
ve.sync = Wa;
ve.async = Ha;
const Vt = x, Y = q, Hn = Ht, Er = L, ws = ve, Va = (t, e, n) => {
  const r = `${t}(path, [criteria])`;
  Er.argument(r, "path", e, ["string"]), Er.options(r, "criteria", n, {
    empty: ["boolean"],
    mode: ["string", "number"]
  });
}, bs = (t) => {
  const e = t || {};
  return typeof e.empty != "boolean" && (e.empty = !1), e.mode !== void 0 && (e.mode = Hn.normalizeFileMode(e.mode)), e;
}, Ss = (t) => new Error(
  `Path ${t} exists but is not a directory. Halting jetpack.dir() call for safety reasons.`
), Ka = (t) => {
  let e;
  try {
    e = Y.statSync(t);
  } catch (n) {
    if (n.code !== "ENOENT")
      throw n;
  }
  if (e && !e.isDirectory())
    throw Ss(t);
  return e;
}, Vn = (t, e) => {
  const n = e || {};
  try {
    Y.mkdirSync(t, n.mode);
  } catch (r) {
    if (r.code === "ENOENT")
      Vn(Vt.dirname(t), n), Y.mkdirSync(t, n.mode);
    else if (r.code !== "EEXIST") throw r;
  }
}, Qa = (t, e, n) => {
  const r = () => {
    const i = Hn.normalizeFileMode(e.mode);
    n.mode !== void 0 && n.mode !== i && Y.chmodSync(t, n.mode);
  }, s = () => {
    n.empty && Y.readdirSync(t).forEach((o) => {
      ws.sync(Vt.resolve(t, o));
    });
  };
  r(), s();
}, Xa = (t, e) => {
  const n = bs(e), r = Ka(t);
  r ? Qa(t, r, n) : Vn(t, n);
}, Ga = (t) => new Promise((e, n) => {
  Y.stat(t).then((r) => {
    r.isDirectory() ? e(r) : n(Ss(t));
  }).catch((r) => {
    r.code === "ENOENT" ? e(void 0) : n(r);
  });
}), Ya = (t) => new Promise((e, n) => {
  Y.readdir(t).then((r) => {
    const s = (i) => {
      if (i === r.length)
        e();
      else {
        const o = Vt.resolve(t, r[i]);
        ws.async(o).then(() => {
          s(i + 1);
        });
      }
    };
    s(0);
  }).catch(n);
}), Za = (t, e, n) => new Promise((r, s) => {
  const i = () => {
    const a = Hn.normalizeFileMode(e.mode);
    return n.mode !== void 0 && n.mode !== a ? Y.chmod(t, n.mode) : Promise.resolve();
  }, o = () => n.empty ? Ya(t) : Promise.resolve();
  i().then(o).then(r, s);
}), Kn = (t, e) => {
  const n = e || {};
  return new Promise((r, s) => {
    Y.mkdir(t, n.mode).then(r).catch((i) => {
      i.code === "ENOENT" ? Kn(Vt.dirname(t), n).then(() => Y.mkdir(t, n.mode)).then(r).catch((o) => {
        o.code === "EEXIST" ? r() : s(o);
      }) : i.code === "EEXIST" ? r() : s(i);
    });
  });
}, ec = (t, e) => new Promise((n, r) => {
  const s = bs(e);
  Ga(t).then((i) => i !== void 0 ? Za(
    t,
    i,
    s
  ) : Kn(t, s)).then(n, r);
});
K.validateInput = Va;
K.sync = Xa;
K.createSync = Vn;
K.async = ec;
K.createAsync = Kn;
const Es = x, Ee = q, dn = L, Os = K, tc = (t, e, n, r) => {
  const s = `${t}(path, data, [options])`;
  dn.argument(s, "path", e, ["string"]), dn.argument(s, "data", n, [
    "string",
    "buffer",
    "object",
    "array"
  ]), dn.options(s, "options", r, {
    mode: ["string", "number"],
    atomic: ["boolean"],
    jsonIndent: ["number"]
  });
}, At = ".__new__", As = (t, e) => {
  let n = e;
  return typeof n != "number" && (n = 2), typeof t == "object" && !Dn.isBuffer(t) && t !== null ? JSON.stringify(t, null, n) : t;
}, $s = (t, e, n) => {
  try {
    Ee.writeFileSync(t, e, n);
  } catch (r) {
    if (r.code === "ENOENT")
      Os.createSync(Es.dirname(t)), Ee.writeFileSync(t, e, n);
    else
      throw r;
  }
}, nc = (t, e, n) => {
  $s(t + At, e, n), Ee.renameSync(t + At, t);
}, rc = (t, e, n) => {
  const r = n || {}, s = As(e, r.jsonIndent);
  let i = $s;
  r.atomic && (i = nc), i(t, s, { mode: r.mode });
}, vs = (t, e, n) => new Promise((r, s) => {
  Ee.writeFile(t, e, n).then(r).catch((i) => {
    i.code === "ENOENT" ? Os.createAsync(Es.dirname(t)).then(() => Ee.writeFile(t, e, n)).then(r, s) : s(i);
  });
}), sc = (t, e, n) => new Promise((r, s) => {
  vs(t + At, e, n).then(() => Ee.rename(t + At, t)).then(r, s);
}), ic = (t, e, n) => {
  const r = n || {}, s = As(e, r.jsonIndent);
  let i = vs;
  return r.atomic && (i = sc), i(t, s, { mode: r.mode });
};
de.validateInput = tc;
de.sync = rc;
de.async = ic;
const Ts = q, ks = de, hn = L, oc = (t, e, n, r) => {
  const s = `${t}(path, data, [options])`;
  hn.argument(s, "path", e, ["string"]), hn.argument(s, "data", n, ["string", "buffer"]), hn.options(s, "options", r, {
    mode: ["string", "number"]
  });
}, ac = (t, e, n) => {
  try {
    Ts.appendFileSync(t, e, n);
  } catch (r) {
    if (r.code === "ENOENT")
      ks.sync(t, e, n);
    else
      throw r;
  }
}, cc = (t, e, n) => new Promise((r, s) => {
  Ts.appendFile(t, e, n).then(r).catch((i) => {
    i.code === "ENOENT" ? ks.async(t, e, n).then(r, s) : s(i);
  });
});
Wt.validateInput = oc;
Wt.sync = ac;
Wt.async = cc;
var Kt = {};
const Qt = q, Qn = Ht, Or = L, Xt = de, lc = (t, e, n) => {
  const r = `${t}(path, [criteria])`;
  Or.argument(r, "path", e, ["string"]), Or.options(r, "criteria", n, {
    content: ["string", "buffer", "object", "array"],
    jsonIndent: ["number"],
    mode: ["string", "number"]
  });
}, Ns = (t) => {
  const e = t || {};
  return e.mode !== void 0 && (e.mode = Qn.normalizeFileMode(e.mode)), e;
}, Rs = (t) => new Error(
  `Path ${t} exists but is not a file. Halting jetpack.file() call for safety reasons.`
), fc = (t) => {
  let e;
  try {
    e = Qt.statSync(t);
  } catch (n) {
    if (n.code !== "ENOENT")
      throw n;
  }
  if (e && !e.isFile())
    throw Rs(t);
  return e;
}, uc = (t, e, n) => {
  const r = Qn.normalizeFileMode(e.mode), s = () => n.content !== void 0 ? (Xt.sync(t, n.content, {
    mode: r,
    jsonIndent: n.jsonIndent
  }), !0) : !1, i = () => {
    n.mode !== void 0 && n.mode !== r && Qt.chmodSync(t, n.mode);
  };
  s() || i();
}, dc = (t, e) => {
  let n = "";
  e.content !== void 0 && (n = e.content), Xt.sync(t, n, {
    mode: e.mode,
    jsonIndent: e.jsonIndent
  });
}, hc = (t, e) => {
  const n = Ns(e), r = fc(t);
  r !== void 0 ? uc(t, r, n) : dc(t, n);
}, mc = (t) => new Promise((e, n) => {
  Qt.stat(t).then((r) => {
    r.isFile() ? e(r) : n(Rs(t));
  }).catch((r) => {
    r.code === "ENOENT" ? e(void 0) : n(r);
  });
}), pc = (t, e, n) => {
  const r = Qn.normalizeFileMode(e.mode), s = () => new Promise((o, a) => {
    n.content !== void 0 ? Xt.async(t, n.content, {
      mode: r,
      jsonIndent: n.jsonIndent
    }).then(() => {
      o(!0);
    }).catch(a) : o(!1);
  }), i = () => {
    if (n.mode !== void 0 && n.mode !== r)
      return Qt.chmod(t, n.mode);
  };
  return s().then((o) => {
    if (!o)
      return i();
  });
}, yc = (t, e) => {
  let n = "";
  return e.content !== void 0 && (n = e.content), Xt.async(t, n, {
    mode: e.mode,
    jsonIndent: e.jsonIndent
  });
}, gc = (t, e) => new Promise((n, r) => {
  const s = Ns(e);
  mc(t).then((i) => i !== void 0 ? pc(t, i, s) : yc(t, s)).then(n, r);
});
Kt.validateInput = lc;
Kt.sync = hc;
Kt.async = gc;
var Gt = {}, Je = {}, ee = {};
const Ps = jn, wc = x, re = q, Ar = L, Pn = ["md5", "sha1", "sha256", "sha512"], Cn = ["report", "follow"], bc = (t, e, n) => {
  const r = `${t}(path, [options])`;
  if (Ar.argument(r, "path", e, ["string"]), Ar.options(r, "options", n, {
    checksum: ["string"],
    mode: ["boolean"],
    times: ["boolean"],
    absolutePath: ["boolean"],
    symlinks: ["string"]
  }), n && n.checksum !== void 0 && Pn.indexOf(n.checksum) === -1)
    throw new Error(
      `Argument "options.checksum" passed to ${r} must have one of values: ${Pn.join(
        ", "
      )}`
    );
  if (n && n.symlinks !== void 0 && Cn.indexOf(n.symlinks) === -1)
    throw new Error(
      `Argument "options.symlinks" passed to ${r} must have one of values: ${Cn.join(
        ", "
      )}`
    );
}, Cs = (t, e, n) => {
  const r = {};
  return r.name = wc.basename(t), n.isFile() ? (r.type = "file", r.size = n.size) : n.isDirectory() ? r.type = "dir" : n.isSymbolicLink() ? r.type = "symlink" : r.type = "other", e.mode && (r.mode = n.mode), e.times && (r.accessTime = n.atime, r.modifyTime = n.mtime, r.changeTime = n.ctime, r.birthTime = n.birthtime), e.absolutePath && (r.absolutePath = t), r;
}, Sc = (t, e) => {
  const n = Ps.createHash(e), r = re.readFileSync(t);
  return n.update(r), n.digest("hex");
}, Ec = (t, e, n) => {
  e.type === "file" && n.checksum ? e[n.checksum] = Sc(t, n.checksum) : e.type === "symlink" && (e.pointsAt = re.readlinkSync(t));
}, Oc = (t, e) => {
  let n = re.lstatSync, r;
  const s = e || {};
  s.symlinks === "follow" && (n = re.statSync);
  try {
    r = n(t);
  } catch (o) {
    if (o.code === "ENOENT")
      return;
    throw o;
  }
  const i = Cs(t, s, r);
  return Ec(t, i, s), i;
}, Ac = (t, e) => new Promise((n, r) => {
  const s = Ps.createHash(e), i = re.createReadStream(t);
  i.on("data", (o) => {
    s.update(o);
  }), i.on("end", () => {
    n(s.digest("hex"));
  }), i.on("error", r);
}), $c = (t, e, n) => e.type === "file" && n.checksum ? Ac(t, n.checksum).then((r) => (e[n.checksum] = r, e)) : e.type === "symlink" ? re.readlink(t).then((r) => (e.pointsAt = r, e)) : Promise.resolve(e), vc = (t, e) => new Promise((n, r) => {
  let s = re.lstat;
  const i = e || {};
  i.symlinks === "follow" && (s = re.stat), s(t).then((o) => {
    const a = Cs(t, i, o);
    $c(t, a, i).then(n, r);
  }).catch((o) => {
    o.code === "ENOENT" ? n(void 0) : r(o);
  });
});
ee.supportedChecksumAlgorithms = Pn;
ee.symlinkOptions = Cn;
ee.validateInput = bc;
ee.sync = Oc;
ee.async = vc;
var Yt = {};
const Fs = q, Tc = L, kc = (t, e) => {
  const n = `${t}(path)`;
  Tc.argument(n, "path", e, ["string", "undefined"]);
}, Nc = (t) => {
  try {
    return Fs.readdirSync(t);
  } catch (e) {
    if (e.code === "ENOENT")
      return;
    throw e;
  }
}, Rc = (t) => new Promise((e, n) => {
  Fs.readdir(t).then((r) => {
    e(r);
  }).catch((r) => {
    r.code === "ENOENT" ? e(void 0) : n(r);
  });
});
Yt.validateInput = kc;
Yt.sync = Nc;
Yt.async = Rc;
const $t = Wn, vt = x, Ie = ee, Tt = (t) => t.isDirectory() ? "dir" : t.isFile() ? "file" : t.isSymbolicLink() ? "symlink" : "other", Pc = (t, e, n) => {
  e.maxLevelsDeep === void 0 && (e.maxLevelsDeep = 1 / 0);
  const r = e.inspectOptions !== void 0;
  e.symlinks && (e.inspectOptions === void 0 ? e.inspectOptions = { symlinks: e.symlinks } : e.inspectOptions.symlinks = e.symlinks);
  const s = (o, a) => {
    $t.readdirSync(o, { withFileTypes: !0 }).forEach((c) => {
      const l = typeof c == "string";
      let f;
      l ? f = vt.join(o, c) : f = vt.join(o, c.name);
      let u;
      if (r)
        u = Ie.sync(f, e.inspectOptions);
      else if (l) {
        const m = Ie.sync(
          f,
          e.inspectOptions
        );
        u = { name: m.name, type: m.type };
      } else {
        const m = Tt(c);
        if (m === "symlink" && e.symlinks === "follow") {
          const g = $t.statSync(f);
          u = { name: c.name, type: Tt(g) };
        } else
          u = { name: c.name, type: m };
      }
      u !== void 0 && (n(f, u), u.type === "dir" && a < e.maxLevelsDeep && s(f, a + 1));
    });
  }, i = Ie.sync(t, e.inspectOptions);
  i ? (r ? n(t, i) : n(t, { name: i.name, type: i.type }), i.type === "dir" && s(t, 1)) : n(t, void 0);
}, Cc = 5, Fc = (t, e, n, r) => {
  e.maxLevelsDeep === void 0 && (e.maxLevelsDeep = 1 / 0);
  const s = e.inspectOptions !== void 0;
  e.symlinks && (e.inspectOptions === void 0 ? e.inspectOptions = { symlinks: e.symlinks } : e.inspectOptions.symlinks = e.symlinks);
  const i = [];
  let o = 0;
  const a = () => {
    if (i.length === 0 && o === 0)
      r();
    else if (i.length > 0 && o < Cc) {
      const u = i.pop();
      o += 1, u();
    }
  }, c = (u) => {
    i.push(u), a();
  }, l = () => {
    o -= 1, a();
  }, f = (u, m) => {
    const g = (h, p) => {
      p.type === "dir" && m < e.maxLevelsDeep && f(h, m + 1);
    };
    c(() => {
      $t.readdir(u, { withFileTypes: !0 }, (h, p) => {
        h ? r(h) : (p.forEach((y) => {
          const O = typeof y == "string";
          let w;
          if (O ? w = vt.join(u, y) : w = vt.join(u, y.name), s || O)
            c(() => {
              Ie.async(w, e.inspectOptions).then((E) => {
                E !== void 0 && (s ? n(w, E) : n(w, {
                  name: E.name,
                  type: E.type
                }), g(w, E)), l();
              }).catch((E) => {
                r(E);
              });
            });
          else {
            const E = Tt(y);
            if (E === "symlink" && e.symlinks === "follow")
              c(() => {
                $t.stat(w, (S, b) => {
                  if (S)
                    r(S);
                  else {
                    const A = {
                      name: y.name,
                      type: Tt(b)
                    };
                    n(w, A), g(w, A), l();
                  }
                });
              });
            else {
              const S = { name: y.name, type: E };
              n(w, S), g(w, S);
            }
          }
        }), l());
      });
    });
  };
  Ie.async(t, e.inspectOptions).then((u) => {
    u ? (s ? n(t, u) : n(t, { name: u.name, type: u.type }), u.type === "dir" ? f(t, 1) : r()) : (n(t, void 0), r());
  }).catch((u) => {
    r(u);
  });
};
Je.sync = Pc;
Je.async = Fc;
var Xn = {};
const Ic = typeof G == "object" && G && G.platform === "win32";
var Lc = Ic ? { sep: "\\" } : { sep: "/" }, Dc = Is;
function Is(t, e, n) {
  t instanceof RegExp && (t = $r(t, n)), e instanceof RegExp && (e = $r(e, n));
  var r = Ls(t, e, n);
  return r && {
    start: r[0],
    end: r[1],
    pre: n.slice(0, r[0]),
    body: n.slice(r[0] + t.length, r[1]),
    post: n.slice(r[1] + e.length)
  };
}
function $r(t, e) {
  var n = e.match(t);
  return n ? n[0] : null;
}
Is.range = Ls;
function Ls(t, e, n) {
  var r, s, i, o, a, c = n.indexOf(t), l = n.indexOf(e, c + 1), f = c;
  if (c >= 0 && l > 0) {
    if (t === e)
      return [c, l];
    for (r = [], i = n.length; f >= 0 && !a; )
      f == c ? (r.push(f), c = n.indexOf(t, f + 1)) : r.length == 1 ? a = [r.pop(), l] : (s = r.pop(), s < i && (i = s, o = l), l = n.indexOf(e, f + 1)), f = c < l && c >= 0 ? c : l;
    r.length && (a = [i, o]);
  }
  return a;
}
var Ds = Dc, jc = _c, js = "\0SLASH" + Math.random() + "\0", Ms = "\0OPEN" + Math.random() + "\0", Gn = "\0CLOSE" + Math.random() + "\0", Bs = "\0COMMA" + Math.random() + "\0", _s = "\0PERIOD" + Math.random() + "\0";
function mn(t) {
  return parseInt(t, 10) == t ? parseInt(t, 10) : t.charCodeAt(0);
}
function Mc(t) {
  return t.split("\\\\").join(js).split("\\{").join(Ms).split("\\}").join(Gn).split("\\,").join(Bs).split("\\.").join(_s);
}
function Bc(t) {
  return t.split(js).join("\\").split(Ms).join("{").split(Gn).join("}").split(Bs).join(",").split(_s).join(".");
}
function Us(t) {
  if (!t)
    return [""];
  var e = [], n = Ds("{", "}", t);
  if (!n)
    return t.split(",");
  var r = n.pre, s = n.body, i = n.post, o = r.split(",");
  o[o.length - 1] += "{" + s + "}";
  var a = Us(i);
  return i.length && (o[o.length - 1] += a.shift(), o.push.apply(o, a)), e.push.apply(e, o), e;
}
function _c(t) {
  return t ? (t.substr(0, 2) === "{}" && (t = "\\{\\}" + t.substr(2)), Pe(Mc(t), !0).map(Bc)) : [];
}
function Uc(t) {
  return "{" + t + "}";
}
function xc(t) {
  return /^-?0\d/.test(t);
}
function qc(t, e) {
  return t <= e;
}
function Jc(t, e) {
  return t >= e;
}
function Pe(t, e) {
  var n = [], r = Ds("{", "}", t);
  if (!r) return [t];
  var s = r.pre, i = r.post.length ? Pe(r.post, !1) : [""];
  if (/\$$/.test(r.pre))
    for (var o = 0; o < i.length; o++) {
      var a = s + "{" + r.body + "}" + i[o];
      n.push(a);
    }
  else {
    var c = /^-?\d+\.\.-?\d+(?:\.\.-?\d+)?$/.test(r.body), l = /^[a-zA-Z]\.\.[a-zA-Z](?:\.\.-?\d+)?$/.test(r.body), f = c || l, u = r.body.indexOf(",") >= 0;
    if (!f && !u)
      return r.post.match(/,.*\}/) ? (t = r.pre + "{" + r.body + Gn + r.post, Pe(t)) : [t];
    var m;
    if (f)
      m = r.body.split(/\.\./);
    else if (m = Us(r.body), m.length === 1 && (m = Pe(m[0], !1).map(Uc), m.length === 1))
      return i.map(function(ke) {
        return r.pre + m[0] + ke;
      });
    var g;
    if (f) {
      var h = mn(m[0]), p = mn(m[1]), y = Math.max(m[0].length, m[1].length), O = m.length == 3 ? Math.abs(mn(m[2])) : 1, w = qc, E = p < h;
      E && (O *= -1, w = Jc);
      var S = m.some(xc);
      g = [];
      for (var b = h; w(b, p); b += O) {
        var A;
        if (l)
          A = String.fromCharCode(b), A === "\\" && (A = "");
        else if (A = String(b), S) {
          var v = y - A.length;
          if (v > 0) {
            var T = new Array(v + 1).join("0");
            b < 0 ? A = "-" + T + A.slice(1) : A = T + A;
          }
        }
        g.push(A);
      }
    } else {
      g = [];
      for (var D = 0; D < m.length; D++)
        g.push.apply(g, Pe(m[D], !1));
    }
    for (var D = 0; D < g.length; D++)
      for (var o = 0; o < i.length; o++) {
        var a = s + g[D] + i[o];
        (!e || f || a) && n.push(a);
      }
  }
  return n;
}
const U = xs = (t, e, n = {}) => (kt(e), !n.nocomment && e.charAt(0) === "#" ? !1 : new Zt(e, n).match(t));
var xs = U;
const Fn = Lc;
U.sep = Fn.sep;
const J = Symbol("globstar **");
U.GLOBSTAR = J;
const zc = jc, vr = {
  "!": { open: "(?:(?!(?:", close: "))[^/]*?)" },
  "?": { open: "(?:", close: ")?" },
  "+": { open: "(?:", close: ")+" },
  "*": { open: "(?:", close: ")*" },
  "@": { open: "(?:", close: ")" }
}, In = "[^/]", pn = In + "*?", Wc = "(?:(?!(?:\\/|^)(?:\\.{1,2})($|\\/)).)*?", Hc = "(?:(?!(?:\\/|^)\\.).)*?", qs = (t) => t.split("").reduce((e, n) => (e[n] = !0, e), {}), Tr = qs("().*{}+?[]^$\\!"), Vc = qs("[.("), kr = /\/+/;
U.filter = (t, e = {}) => (n, r, s) => U(n, t, e);
const ne = (t, e = {}) => {
  const n = {};
  return Object.keys(t).forEach((r) => n[r] = t[r]), Object.keys(e).forEach((r) => n[r] = e[r]), n;
};
U.defaults = (t) => {
  if (!t || typeof t != "object" || !Object.keys(t).length)
    return U;
  const e = U, n = (r, s, i) => e(r, s, ne(t, i));
  return n.Minimatch = class extends e.Minimatch {
    constructor(s, i) {
      super(s, ne(t, i));
    }
  }, n.Minimatch.defaults = (r) => e.defaults(ne(t, r)).Minimatch, n.filter = (r, s) => e.filter(r, ne(t, s)), n.defaults = (r) => e.defaults(ne(t, r)), n.makeRe = (r, s) => e.makeRe(r, ne(t, s)), n.braceExpand = (r, s) => e.braceExpand(r, ne(t, s)), n.match = (r, s, i) => e.match(r, s, ne(t, i)), n;
};
U.braceExpand = (t, e) => Js(t, e);
const Js = (t, e = {}) => (kt(t), e.nobrace || !/\{(?:(?!\{).)*\}/.test(t) ? [t] : zc(t)), Kc = 1024 * 64, kt = (t) => {
  if (typeof t != "string")
    throw new TypeError("invalid pattern");
  if (t.length > Kc)
    throw new TypeError("pattern is too long");
}, Ve = Symbol("subparse");
U.makeRe = (t, e) => new Zt(t, e || {}).makeRe();
U.match = (t, e, n = {}) => {
  const r = new Zt(e, n);
  return t = t.filter((s) => r.match(s)), r.options.nonull && !t.length && t.push(e), t;
};
const Qc = (t) => t.replace(/\\(.)/g, "$1"), Xc = (t) => t.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
let Zt = class {
  constructor(e, n) {
    kt(e), n || (n = {}), this.options = n, this.set = [], this.pattern = e, this.windowsPathsNoEscape = !!n.windowsPathsNoEscape || n.allowWindowsEscape === !1, this.windowsPathsNoEscape && (this.pattern = this.pattern.replace(/\\/g, "/")), this.regexp = null, this.negate = !1, this.comment = !1, this.empty = !1, this.partial = !!n.partial, this.make();
  }
  debug() {
  }
  make() {
    const e = this.pattern, n = this.options;
    if (!n.nocomment && e.charAt(0) === "#") {
      this.comment = !0;
      return;
    }
    if (!e) {
      this.empty = !0;
      return;
    }
    this.parseNegate();
    let r = this.globSet = this.braceExpand();
    n.debug && (this.debug = (...s) => console.error(...s)), this.debug(this.pattern, r), r = this.globParts = r.map((s) => s.split(kr)), this.debug(this.pattern, r), r = r.map((s, i, o) => s.map(this.parse, this)), this.debug(this.pattern, r), r = r.filter((s) => s.indexOf(!1) === -1), this.debug(this.pattern, r), this.set = r;
  }
  parseNegate() {
    if (this.options.nonegate) return;
    const e = this.pattern;
    let n = !1, r = 0;
    for (let s = 0; s < e.length && e.charAt(s) === "!"; s++)
      n = !n, r++;
    r && (this.pattern = e.slice(r)), this.negate = n;
  }
  // set partial to true to test if, for example,
  // "/a/b" matches the start of "/*/b/*/d"
  // Partial means, if you run out of file before you run
  // out of pattern, then that's fine, as long as all
  // the parts match.
  matchOne(e, n, r) {
    var s = this.options;
    this.debug(
      "matchOne",
      { this: this, file: e, pattern: n }
    ), this.debug("matchOne", e.length, n.length);
    for (var i = 0, o = 0, a = e.length, c = n.length; i < a && o < c; i++, o++) {
      this.debug("matchOne loop");
      var l = n[o], f = e[i];
      if (this.debug(n, l, f), l === !1) return !1;
      if (l === J) {
        this.debug("GLOBSTAR", [n, l, f]);
        var u = i, m = o + 1;
        if (m === c) {
          for (this.debug("** at the end"); i < a; i++)
            if (e[i] === "." || e[i] === ".." || !s.dot && e[i].charAt(0) === ".") return !1;
          return !0;
        }
        for (; u < a; ) {
          var g = e[u];
          if (this.debug(`
globstar while`, e, u, n, m, g), this.matchOne(e.slice(u), n.slice(m), r))
            return this.debug("globstar found match!", u, a, g), !0;
          if (g === "." || g === ".." || !s.dot && g.charAt(0) === ".") {
            this.debug("dot detected!", e, u, n, m);
            break;
          }
          this.debug("globstar swallow a segment, and continue"), u++;
        }
        return !!(r && (this.debug(`
>>> no match, partial?`, e, u, n, m), u === a));
      }
      var h;
      if (typeof l == "string" ? (h = f === l, this.debug("string match", l, f, h)) : (h = f.match(l), this.debug("pattern match", l, f, h)), !h) return !1;
    }
    if (i === a && o === c)
      return !0;
    if (i === a)
      return r;
    if (o === c)
      return i === a - 1 && e[i] === "";
    throw new Error("wtf?");
  }
  braceExpand() {
    return Js(this.pattern, this.options);
  }
  parse(e, n) {
    kt(e);
    const r = this.options;
    if (e === "**")
      if (r.noglobstar)
        e = "*";
      else
        return J;
    if (e === "") return "";
    let s = "", i = !!r.nocase, o = !1;
    const a = [], c = [];
    let l, f = !1, u = -1, m = -1, g, h, p;
    const y = e.charAt(0) === "." ? "" : r.dot ? "(?!(?:^|\\/)\\.{1,2}(?:$|\\/))" : "(?!\\.)", O = () => {
      if (l) {
        switch (l) {
          case "*":
            s += pn, i = !0;
            break;
          case "?":
            s += In, i = !0;
            break;
          default:
            s += "\\" + l;
            break;
        }
        this.debug("clearStateChar %j %j", l, s), l = !1;
      }
    };
    for (let S = 0, b; S < e.length && (b = e.charAt(S)); S++) {
      if (this.debug("%s	%s %s %j", e, S, s, b), o) {
        if (b === "/")
          return !1;
        Tr[b] && (s += "\\"), s += b, o = !1;
        continue;
      }
      switch (b) {
        case "/":
          return !1;
        case "\\":
          O(), o = !0;
          continue;
        case "?":
        case "*":
        case "+":
        case "@":
        case "!":
          if (this.debug("%s	%s %s %j <-- stateChar", e, S, s, b), f) {
            this.debug("  in class"), b === "!" && S === m + 1 && (b = "^"), s += b;
            continue;
          }
          this.debug("call clearStateChar %j", l), O(), l = b, r.noext && O();
          continue;
        case "(":
          if (f) {
            s += "(";
            continue;
          }
          if (!l) {
            s += "\\(";
            continue;
          }
          a.push({
            type: l,
            start: S - 1,
            reStart: s.length,
            open: vr[l].open,
            close: vr[l].close
          }), s += l === "!" ? "(?:(?!(?:" : "(?:", this.debug("plType %j %j", l, s), l = !1;
          continue;
        case ")":
          if (f || !a.length) {
            s += "\\)";
            continue;
          }
          O(), i = !0, h = a.pop(), s += h.close, h.type === "!" && c.push(h), h.reEnd = s.length;
          continue;
        case "|":
          if (f || !a.length) {
            s += "\\|";
            continue;
          }
          O(), s += "|";
          continue;
        case "[":
          if (O(), f) {
            s += "\\" + b;
            continue;
          }
          f = !0, m = S, u = s.length, s += b;
          continue;
        case "]":
          if (S === m + 1 || !f) {
            s += "\\" + b;
            continue;
          }
          g = e.substring(m + 1, S);
          try {
            RegExp("[" + g + "]");
          } catch {
            p = this.parse(g, Ve), s = s.substring(0, u) + "\\[" + p[0] + "\\]", i = i || p[1], f = !1;
            continue;
          }
          i = !0, f = !1, s += b;
          continue;
        default:
          O(), Tr[b] && !(b === "^" && f) && (s += "\\"), s += b;
          break;
      }
    }
    for (f && (g = e.slice(m + 1), p = this.parse(g, Ve), s = s.substring(0, u) + "\\[" + p[0], i = i || p[1]), h = a.pop(); h; h = a.pop()) {
      let S;
      S = s.slice(h.reStart + h.open.length), this.debug("setting tail", s, h), S = S.replace(/((?:\\{2}){0,64})(\\?)\|/g, (A, v, T) => (T || (T = "\\"), v + v + T + "|")), this.debug(`tail=%j
   %s`, S, S, h, s);
      const b = h.type === "*" ? pn : h.type === "?" ? In : "\\" + h.type;
      i = !0, s = s.slice(0, h.reStart) + b + "\\(" + S;
    }
    O(), o && (s += "\\\\");
    const w = Vc[s.charAt(0)];
    for (let S = c.length - 1; S > -1; S--) {
      const b = c[S], A = s.slice(0, b.reStart), v = s.slice(b.reStart, b.reEnd - 8);
      let T = s.slice(b.reEnd);
      const D = s.slice(b.reEnd - 8, b.reEnd) + T, ke = A.split("(").length - 1;
      let he = T;
      for (let rr = 0; rr < ke; rr++)
        he = he.replace(/\)[+*?]?/, "");
      T = he;
      const te = T === "" && n !== Ve ? "$" : "";
      s = A + v + T + te + D;
    }
    if (s !== "" && i && (s = "(?=.)" + s), w && (s = y + s), n === Ve)
      return [s, i];
    if (!i)
      return Qc(e);
    const E = r.nocase ? "i" : "";
    try {
      return Object.assign(new RegExp("^" + s + "$", E), {
        _glob: e,
        _src: s
      });
    } catch {
      return new RegExp("$.");
    }
  }
  makeRe() {
    if (this.regexp || this.regexp === !1) return this.regexp;
    const e = this.set;
    if (!e.length)
      return this.regexp = !1, this.regexp;
    const n = this.options, r = n.noglobstar ? pn : n.dot ? Wc : Hc, s = n.nocase ? "i" : "";
    let i = e.map((o) => (o = o.map(
      (a) => typeof a == "string" ? Xc(a) : a === J ? J : a._src
    ).reduce((a, c) => (a[a.length - 1] === J && c === J || a.push(c), a), []), o.forEach((a, c) => {
      a !== J || o[c - 1] === J || (c === 0 ? o.length > 1 ? o[c + 1] = "(?:\\/|" + r + "\\/)?" + o[c + 1] : o[c] = r : c === o.length - 1 ? o[c - 1] += "(?:\\/|" + r + ")?" : (o[c - 1] += "(?:\\/|\\/" + r + "\\/)" + o[c + 1], o[c + 1] = J));
    }), o.filter((a) => a !== J).join("/"))).join("|");
    i = "^(?:" + i + ")$", this.negate && (i = "^(?!" + i + ").*$");
    try {
      this.regexp = new RegExp(i, s);
    } catch {
      this.regexp = !1;
    }
    return this.regexp;
  }
  match(e, n = this.partial) {
    if (this.debug("match", e, this.pattern), this.comment) return !1;
    if (this.empty) return e === "";
    if (e === "/" && n) return !0;
    const r = this.options;
    Fn.sep !== "/" && (e = e.split(Fn.sep).join("/")), e = e.split(kr), this.debug(this.pattern, "split", e);
    const s = this.set;
    this.debug(this.pattern, "set", s);
    let i;
    for (let o = e.length - 1; o >= 0 && (i = e[o], !i); o--)
      ;
    for (let o = 0; o < s.length; o++) {
      const a = s[o];
      let c = e;
      if (r.matchBase && a.length === 1 && (c = [i]), this.matchOne(c, a, n))
        return r.flipNegate ? !0 : !this.negate;
    }
    return r.flipNegate ? !1 : this.negate;
  }
  static defaults(e) {
    return U.defaults(e).Minimatch;
  }
};
U.Minimatch = Zt;
const Gc = xs.Minimatch, Yc = (t, e) => {
  const n = e.indexOf("/") !== -1, r = /^!?\//.test(e), s = /^!/.test(e);
  let i;
  if (!r && n) {
    const o = e.replace(/^!/, "").replace(/^\.\//, "");
    return /\/$/.test(t) ? i = "" : i = "/", s ? `!${t}${i}${o}` : `${t}${i}${o}`;
  }
  return e;
};
Xn.create = (t, e, n) => {
  let r;
  typeof e == "string" ? r = [e] : r = e;
  const s = r.map((o) => Yc(t, o)).map((o) => new Gc(o, {
    matchBase: !0,
    nocomment: !0,
    nocase: n || !1,
    dot: !0,
    windowsPathsNoEscape: !0
  }));
  return (o) => {
    let a = "matching", c = !1, l, f;
    for (f = 0; f < s.length; f += 1) {
      if (l = s[f], l.negate && (a = "negation", f === 0 && (c = !0)), a === "negation" && c && !l.match(o))
        return !1;
      a === "matching" && !c && (c = l.match(o));
    }
    return c;
  };
};
const Zc = x, zs = Je, Ws = ee, Hs = Xn, Nr = L, el = (t, e, n) => {
  const r = `${t}([path], options)`;
  Nr.argument(r, "path", e, ["string"]), Nr.options(r, "options", n, {
    matching: ["string", "array of string"],
    filter: ["function"],
    files: ["boolean"],
    directories: ["boolean"],
    recursive: ["boolean"],
    ignoreCase: ["boolean"]
  });
}, Vs = (t) => {
  const e = t || {};
  return e.matching === void 0 && (e.matching = "*"), e.files === void 0 && (e.files = !0), e.ignoreCase === void 0 && (e.ignoreCase = !1), e.directories === void 0 && (e.directories = !1), e.recursive === void 0 && (e.recursive = !0), e;
}, Ks = (t, e) => t.map((n) => Zc.relative(e, n)), Qs = (t) => {
  const e = new Error(`Path you want to find stuff in doesn't exist ${t}`);
  return e.code = "ENOENT", e;
}, Xs = (t) => {
  const e = new Error(
    `Path you want to find stuff in must be a directory ${t}`
  );
  return e.code = "ENOTDIR", e;
}, tl = (t, e) => {
  const n = [], r = Hs.create(
    t,
    e.matching,
    e.ignoreCase
  );
  let s = 1 / 0;
  return e.recursive === !1 && (s = 1), zs.sync(
    t,
    {
      maxLevelsDeep: s,
      symlinks: "follow",
      inspectOptions: { times: !0, absolutePath: !0 }
    },
    (i, o) => {
      o && i !== t && r(i) && (o.type === "file" && e.files === !0 || o.type === "dir" && e.directories === !0) && (e.filter ? e.filter(o) && n.push(i) : n.push(i));
    }
  ), n.sort(), Ks(n, e.cwd);
}, nl = (t, e) => {
  const n = Ws.sync(t, { symlinks: "follow" });
  if (n === void 0)
    throw Qs(t);
  if (n.type !== "dir")
    throw Xs(t);
  return tl(t, Vs(e));
}, rl = (t, e) => new Promise((n, r) => {
  const s = [], i = Hs.create(
    t,
    e.matching,
    e.ignoreCase
  );
  let o = 1 / 0;
  e.recursive === !1 && (o = 1);
  let a = 0, c = !1;
  const l = () => {
    c && a === 0 && (s.sort(), n(Ks(s, e.cwd)));
  };
  zs.async(
    t,
    {
      maxLevelsDeep: o,
      symlinks: "follow",
      inspectOptions: { times: !0, absolutePath: !0 }
    },
    (f, u) => {
      if (u && f !== t && i(f) && (u.type === "file" && e.files === !0 || u.type === "dir" && e.directories === !0))
        if (e.filter) {
          const g = e.filter(u);
          typeof g.then == "function" ? (a += 1, g.then((p) => {
            p && s.push(f), a -= 1, l();
          }).catch((p) => {
            r(p);
          })) : g && s.push(f);
        } else
          s.push(f);
    },
    (f) => {
      f ? r(f) : (c = !0, l());
    }
  );
}), sl = (t, e) => Ws.async(t, { symlinks: "follow" }).then((n) => {
  if (n === void 0)
    throw Qs(t);
  if (n.type !== "dir")
    throw Xs(t);
  return rl(t, Vs(e));
});
Gt.validateInput = el;
Gt.sync = nl;
Gt.async = sl;
var en = {};
const il = jn, Nt = x, Ke = ee, Rr = L, Gs = Je, ol = (t, e, n) => {
  const r = `${t}(path, [options])`;
  if (Rr.argument(r, "path", e, ["string"]), Rr.options(r, "options", n, {
    checksum: ["string"],
    relativePath: ["boolean"],
    times: ["boolean"],
    symlinks: ["string"]
  }), n && n.checksum !== void 0 && Ke.supportedChecksumAlgorithms.indexOf(n.checksum) === -1)
    throw new Error(
      `Argument "options.checksum" passed to ${r} must have one of values: ${Ke.supportedChecksumAlgorithms.join(
        ", "
      )}`
    );
  if (n && n.symlinks !== void 0 && Ke.symlinkOptions.indexOf(n.symlinks) === -1)
    throw new Error(
      `Argument "options.symlinks" passed to ${r} must have one of values: ${Ke.symlinkOptions.join(
        ", "
      )}`
    );
}, al = (t, e) => t === void 0 ? "." : t.relativePath + "/" + e.name, cl = (t, e) => {
  const n = il.createHash(e);
  return t.forEach((r) => {
    n.update(r.name + r[e]);
  }), n.digest("hex");
}, Yn = (t, e, n) => {
  n.relativePath && (e.relativePath = al(t, e)), e.type === "dir" && (e.children.forEach((r) => {
    Yn(e, r, n);
  }), e.size = 0, e.children.sort((r, s) => r.type === "dir" && s.type === "file" ? -1 : r.type === "file" && s.type === "dir" ? 1 : r.name.localeCompare(s.name)), e.children.forEach((r) => {
    e.size += r.size || 0;
  }), n.checksum && (e[n.checksum] = cl(
    e.children,
    n.checksum
  )));
}, Zn = (t, e, n) => {
  const r = e[0];
  if (e.length > 1) {
    const s = t.children.find((i) => i.name === r);
    return Zn(s, e.slice(1));
  }
  return t;
}, ll = (t, e) => {
  const n = e || {};
  let r;
  return Gs.sync(t, { inspectOptions: n }, (s, i) => {
    if (i) {
      i.type === "dir" && (i.children = []);
      const o = Nt.relative(t, s);
      o === "" ? r = i : Zn(
        r,
        o.split(Nt.sep)
      ).children.push(i);
    }
  }), r && Yn(void 0, r, n), r;
}, fl = (t, e) => {
  const n = e || {};
  let r;
  return new Promise((s, i) => {
    Gs.async(
      t,
      { inspectOptions: n },
      (o, a) => {
        if (a) {
          a.type === "dir" && (a.children = []);
          const c = Nt.relative(t, o);
          c === "" ? r = a : Zn(
            r,
            c.split(Nt.sep)
          ).children.push(a);
        }
      },
      (o) => {
        o ? i(o) : (r && Yn(void 0, r, n), s(r));
      }
    );
  });
};
en.validateInput = ol;
en.sync = ll;
en.async = fl;
var ze = {}, Te = {};
const Ys = q, ul = L, dl = (t, e) => {
  const n = `${t}(path)`;
  ul.argument(n, "path", e, ["string"]);
}, hl = (t) => {
  try {
    const e = Ys.statSync(t);
    return e.isDirectory() ? "dir" : e.isFile() ? "file" : "other";
  } catch (e) {
    if (e.code !== "ENOENT")
      throw e;
  }
  return !1;
}, ml = (t) => new Promise((e, n) => {
  Ys.stat(t).then((r) => {
    r.isDirectory() ? e("dir") : r.isFile() ? e("file") : e("other");
  }).catch((r) => {
    r.code === "ENOENT" ? e(!1) : n(r);
  });
});
Te.validateInput = dl;
Te.sync = hl;
Te.async = ml;
const Me = x, B = q, er = K, Rt = Te, Zs = ee, pl = de, yl = Xn, ei = Ht, ti = Je, yn = L, gl = (t, e, n, r) => {
  const s = `${t}(from, to, [options])`;
  yn.argument(s, "from", e, ["string"]), yn.argument(s, "to", n, ["string"]), yn.options(s, "options", r, {
    overwrite: ["boolean", "function"],
    matching: ["string", "array of string"],
    ignoreCase: ["boolean"]
  });
}, ni = (t, e) => {
  const n = t || {}, r = {};
  return n.ignoreCase === void 0 && (n.ignoreCase = !1), r.overwrite = n.overwrite, n.matching ? r.allowedToCopy = yl.create(
    e,
    n.matching,
    n.ignoreCase
  ) : r.allowedToCopy = () => !0, r;
}, ri = (t) => {
  const e = new Error(`Path to copy doesn't exist ${t}`);
  return e.code = "ENOENT", e;
}, tn = (t) => {
  const e = new Error(`Destination path already exists ${t}`);
  return e.code = "EEXIST", e;
}, nn = {
  mode: !0,
  symlinks: "report",
  times: !0,
  absolutePath: !0
}, si = (t) => typeof t.opts.overwrite != "function" && t.opts.overwrite !== !0, wl = (t, e, n) => {
  if (!Rt.sync(t))
    throw ri(t);
  if (Rt.sync(e) && !n.overwrite)
    throw tn(e);
}, bl = (t) => {
  if (typeof t.opts.overwrite == "function") {
    const e = Zs.sync(t.destPath, nn);
    return t.opts.overwrite(t.srcInspectData, e);
  }
  return t.opts.overwrite === !0;
}, Sl = (t, e, n, r) => {
  const s = B.readFileSync(t);
  try {
    B.writeFileSync(e, s, { mode: n, flag: "wx" });
  } catch (i) {
    if (i.code === "ENOENT")
      pl.sync(e, s, { mode: n });
    else if (i.code === "EEXIST") {
      if (bl(r))
        B.writeFileSync(e, s, { mode: n });
      else if (si(r))
        throw tn(r.destPath);
    } else
      throw i;
  }
}, El = (t, e) => {
  const n = B.readlinkSync(t);
  try {
    B.symlinkSync(n, e);
  } catch (r) {
    if (r.code === "EEXIST")
      B.unlinkSync(e), B.symlinkSync(n, e);
    else
      throw r;
  }
}, Ol = (t, e, n, r) => {
  const s = { srcPath: t, destPath: n, srcInspectData: e, opts: r }, i = ei.normalizeFileMode(e.mode);
  e.type === "dir" ? er.createSync(n, { mode: i }) : e.type === "file" ? Sl(t, n, i, s) : e.type === "symlink" && El(t, n);
}, Al = (t, e, n) => {
  const r = ni(n, t);
  wl(t, e, r), ti.sync(t, { inspectOptions: nn }, (s, i) => {
    const o = Me.relative(t, s), a = Me.resolve(e, o);
    r.allowedToCopy(s, a, i) && Ol(s, i, a, r);
  });
}, $l = (t, e, n) => Rt.async(t).then((r) => {
  if (r)
    return Rt.async(e);
  throw ri(t);
}).then((r) => {
  if (r && !n.overwrite)
    throw tn(e);
}), vl = (t) => new Promise((e, n) => {
  typeof t.opts.overwrite == "function" ? Zs.async(t.destPath, nn).then((r) => {
    e(
      t.opts.overwrite(t.srcInspectData, r)
    );
  }).catch(n) : e(t.opts.overwrite === !0);
}), Ln = (t, e, n, r, s) => new Promise((i, o) => {
  const a = s || {};
  let c = "wx";
  a.overwrite && (c = "w");
  const l = B.createReadStream(t), f = B.createWriteStream(e, { mode: n, flags: c });
  l.on("error", o), f.on("error", (u) => {
    l.resume(), u.code === "ENOENT" ? er.createAsync(Me.dirname(e)).then(() => {
      Ln(t, e, n, r).then(
        i,
        o
      );
    }).catch(o) : u.code === "EEXIST" ? vl(r).then((m) => {
      m ? Ln(t, e, n, r, {
        overwrite: !0
      }).then(i, o) : si(r) ? o(tn(e)) : i();
    }).catch(o) : o(u);
  }), f.on("finish", i), l.pipe(f);
}), Tl = (t, e) => B.readlink(t).then((n) => new Promise((r, s) => {
  B.symlink(n, e).then(r).catch((i) => {
    i.code === "EEXIST" ? B.unlink(e).then(() => B.symlink(n, e)).then(r, s) : s(i);
  });
})), kl = (t, e, n, r) => {
  const s = { srcPath: t, destPath: n, srcInspectData: e, opts: r }, i = ei.normalizeFileMode(e.mode);
  return e.type === "dir" ? er.createAsync(n, { mode: i }) : e.type === "file" ? Ln(t, n, i, s) : e.type === "symlink" ? Tl(t, n) : Promise.resolve();
}, Nl = (t, e, n) => new Promise((r, s) => {
  const i = ni(n, t);
  $l(t, e, i).then(() => {
    let o = !1, a = 0;
    ti.async(
      t,
      { inspectOptions: nn },
      (c, l) => {
        if (l) {
          const f = Me.relative(t, c), u = Me.resolve(e, f);
          i.allowedToCopy(c, l, u) && (a += 1, kl(c, l, u, i).then(() => {
            a -= 1, o && a === 0 && r();
          }).catch(s));
        }
      },
      (c) => {
        c ? s(c) : (o = !0, o && a === 0 && r());
      }
    );
  }).catch(s);
});
ze.validateInput = gl;
ze.sync = Al;
ze.async = Nl;
var We = {};
const ii = x, Se = q, gn = L, oi = ze, ai = K, Be = Te, Pt = ve, Rl = (t, e, n, r) => {
  const s = `${t}(from, to, [options])`;
  gn.argument(s, "from", e, ["string"]), gn.argument(s, "to", n, ["string"]), gn.options(s, "options", r, {
    overwrite: ["boolean"]
  });
}, ci = (t) => t || {}, li = (t) => {
  const e = new Error(`Destination path already exists ${t}`);
  return e.code = "EEXIST", e;
}, fi = (t) => {
  const e = new Error(`Path to move doesn't exist ${t}`);
  return e.code = "ENOENT", e;
}, Pl = (t, e, n) => {
  const r = ci(n);
  if (Be.sync(e) !== !1 && r.overwrite !== !0)
    throw li(e);
  try {
    Se.renameSync(t, e);
  } catch (s) {
    if (s.code === "EISDIR" || s.code === "EPERM")
      Pt.sync(e), Se.renameSync(t, e);
    else if (s.code === "EXDEV")
      oi.sync(t, e, { overwrite: !0 }), Pt.sync(t);
    else if (s.code === "ENOENT") {
      if (!Be.sync(t))
        throw fi(t);
      ai.createSync(ii.dirname(e)), Se.renameSync(t, e);
    } else
      throw s;
  }
}, Cl = (t) => new Promise((e, n) => {
  const r = ii.dirname(t);
  Be.async(r).then((s) => {
    s ? n() : ai.createAsync(r).then(e, n);
  }).catch(n);
}), Fl = (t, e, n) => {
  const r = ci(n);
  return new Promise((s, i) => {
    Be.async(e).then((o) => {
      o !== !1 && r.overwrite !== !0 ? i(li(e)) : Se.rename(t, e).then(s).catch((a) => {
        a.code === "EISDIR" || a.code === "EPERM" ? Pt.async(e).then(() => Se.rename(t, e)).then(s, i) : a.code === "EXDEV" ? oi.async(t, e, { overwrite: !0 }).then(() => Pt.async(t)).then(s, i) : a.code === "ENOENT" ? Be.async(t).then((c) => {
          c ? Cl(e).then(() => Se.rename(t, e)).then(s, i) : i(fi(t));
        }).catch(i) : i(a);
      });
    });
  });
};
We.validateInput = Rl;
We.sync = Pl;
We.async = Fl;
var rn = {};
const ui = q, Pr = L, Cr = ["utf8", "buffer", "json", "jsonWithDates"], Il = (t, e, n) => {
  const r = `${t}(path, returnAs)`;
  if (Pr.argument(r, "path", e, ["string"]), Pr.argument(r, "returnAs", n, [
    "string",
    "undefined"
  ]), n && Cr.indexOf(n) === -1)
    throw new Error(
      `Argument "returnAs" passed to ${r} must have one of values: ${Cr.join(
        ", "
      )}`
    );
}, di = (t, e) => typeof e == "string" && /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*))(?:Z|(\+|-)([\d|:]*))?$/.exec(e) ? new Date(e) : e, hi = (t, e) => {
  const n = new Error(
    `JSON parsing failed while reading ${t} [${e}]`
  );
  return n.originalError = e, n;
}, Ll = (t, e) => {
  const n = e || "utf8";
  let r, s = "utf8";
  n === "buffer" && (s = null);
  try {
    r = ui.readFileSync(t, { encoding: s });
  } catch (i) {
    if (i.code === "ENOENT")
      return;
    throw i;
  }
  try {
    n === "json" ? r = JSON.parse(r) : n === "jsonWithDates" && (r = JSON.parse(r, di));
  } catch (i) {
    throw hi(t, i);
  }
  return r;
}, Dl = (t, e) => new Promise((n, r) => {
  const s = e || "utf8";
  let i = "utf8";
  s === "buffer" && (i = null), ui.readFile(t, { encoding: i }).then((o) => {
    try {
      n(s === "json" ? JSON.parse(o) : s === "jsonWithDates" ? JSON.parse(o, di) : o);
    } catch (a) {
      r(hi(t, a));
    }
  }).catch((o) => {
    o.code === "ENOENT" ? n(void 0) : r(o);
  });
});
rn.validateInput = Il;
rn.sync = Ll;
rn.async = Dl;
var sn = {};
const _e = x, mi = We, wn = L, jl = (t, e, n, r) => {
  const s = `${t}(path, newName, [options])`;
  if (wn.argument(s, "path", e, ["string"]), wn.argument(s, "newName", n, ["string"]), wn.options(s, "options", r, {
    overwrite: ["boolean"]
  }), _e.basename(n) !== n)
    throw new Error(
      `Argument "newName" passed to ${s} should be a filename, not a path. Received "${n}"`
    );
}, Ml = (t, e, n) => {
  const r = _e.join(_e.dirname(t), e);
  mi.sync(t, r, n);
}, Bl = (t, e, n) => {
  const r = _e.join(_e.dirname(t), e);
  return mi.async(t, r, n);
};
sn.validateInput = jl;
sn.sync = Ml;
sn.async = Bl;
var on = {};
const pi = x, Ct = q, Fr = L, yi = K, _l = (t, e, n) => {
  const r = `${t}(symlinkValue, path)`;
  Fr.argument(r, "symlinkValue", e, ["string"]), Fr.argument(r, "path", n, ["string"]);
}, Ul = (t, e) => {
  try {
    Ct.symlinkSync(t, e);
  } catch (n) {
    if (n.code === "ENOENT")
      yi.createSync(pi.dirname(e)), Ct.symlinkSync(t, e);
    else
      throw n;
  }
}, xl = (t, e) => new Promise((n, r) => {
  Ct.symlink(t, e).then(n).catch((s) => {
    s.code === "ENOENT" ? yi.createAsync(pi.dirname(e)).then(() => Ct.symlink(t, e)).then(n, r) : r(s);
  });
});
on.validateInput = _l;
on.sync = Ul;
on.async = xl;
var tr = {};
const gi = Wn;
tr.createWriteStream = gi.createWriteStream;
tr.createReadStream = gi.createReadStream;
var an = {}, C = {};
C.endianness = function() {
  return "LE";
};
C.hostname = function() {
  return typeof location < "u" ? location.hostname : "";
};
C.loadavg = function() {
  return [];
};
C.uptime = function() {
  return 0;
};
C.freemem = function() {
  return Number.MAX_VALUE;
};
C.totalmem = function() {
  return Number.MAX_VALUE;
};
C.cpus = function() {
  return [];
};
C.type = function() {
  return "Browser";
};
C.release = function() {
  return typeof navigator < "u" ? navigator.appVersion : "";
};
C.networkInterfaces = C.getNetworkInterfaces = function() {
  return {};
};
C.arch = function() {
  return "javascript";
};
C.platform = function() {
  return "browser";
};
C.tmpdir = C.tmpDir = function() {
  return "/tmp";
};
C.EOL = `
`;
C.homedir = function() {
  return "/";
};
const nr = x, ql = C, wi = jn, bi = K, Si = q, Jl = L, zl = (t, e) => {
  const n = `${t}([options])`;
  Jl.options(n, "options", e, {
    prefix: ["string"],
    basePath: ["string"]
  });
}, Ei = (t, e) => {
  t = t || {};
  const n = {};
  return typeof t.prefix != "string" ? n.prefix = "" : n.prefix = t.prefix, typeof t.basePath == "string" ? n.basePath = nr.resolve(e, t.basePath) : n.basePath = ql.tmpdir(), n;
}, Oi = 32, Wl = (t, e) => {
  const n = Ei(e, t), r = wi.randomBytes(Oi / 2).toString("hex"), s = nr.join(
    n.basePath,
    n.prefix + r
  );
  try {
    Si.mkdirSync(s);
  } catch (i) {
    if (i.code === "ENOENT")
      bi.sync(s);
    else
      throw i;
  }
  return s;
}, Hl = (t, e) => new Promise((n, r) => {
  const s = Ei(e, t);
  wi.randomBytes(Oi / 2, (i, o) => {
    if (i)
      r(i);
    else {
      const a = o.toString("hex"), c = nr.join(
        s.basePath,
        s.prefix + a
      );
      Si.mkdir(c, (l) => {
        l ? l.code === "ENOENT" ? bi.async(c).then(() => {
          n(c);
        }, r) : r(l) : n(c);
      });
    }
  });
});
an.validateInput = zl;
an.sync = Wl;
an.async = Hl;
const Ir = vi, bn = x, Qe = Wt, Xe = K, Ge = Kt, Ye = Gt, Ze = ee, et = en, tt = ze, nt = Te, rt = Yt, st = We, it = rn, ot = ve, at = sn, ct = on, Lr = tr, lt = an, ft = de, Ai = (t) => {
  const e = () => t || G.cwd(), n = function() {
    if (arguments.length === 0)
      return e();
    const a = Array.prototype.slice.call(arguments), c = [e()].concat(a);
    return Ai(bn.resolve.apply(null, c));
  }, r = (a) => bn.resolve(e(), a), s = function() {
    return Array.prototype.unshift.call(arguments, e()), bn.resolve.apply(null, arguments);
  }, i = (a) => {
    const c = a || {};
    return c.cwd = e(), c;
  }, o = {
    cwd: n,
    path: s,
    append: (a, c, l) => {
      Qe.validateInput("append", a, c, l), Qe.sync(r(a), c, l);
    },
    appendAsync: (a, c, l) => (Qe.validateInput("appendAsync", a, c, l), Qe.async(r(a), c, l)),
    copy: (a, c, l) => {
      tt.validateInput("copy", a, c, l), tt.sync(r(a), r(c), l);
    },
    copyAsync: (a, c, l) => (tt.validateInput("copyAsync", a, c, l), tt.async(r(a), r(c), l)),
    createWriteStream: (a, c) => Lr.createWriteStream(r(a), c),
    createReadStream: (a, c) => Lr.createReadStream(r(a), c),
    dir: (a, c) => {
      Xe.validateInput("dir", a, c);
      const l = r(a);
      return Xe.sync(l, c), n(l);
    },
    dirAsync: (a, c) => (Xe.validateInput("dirAsync", a, c), new Promise((l, f) => {
      const u = r(a);
      Xe.async(u, c).then(() => {
        l(n(u));
      }, f);
    })),
    exists: (a) => (nt.validateInput("exists", a), nt.sync(r(a))),
    existsAsync: (a) => (nt.validateInput("existsAsync", a), nt.async(r(a))),
    file: (a, c) => (Ge.validateInput("file", a, c), Ge.sync(r(a), c), o),
    fileAsync: (a, c) => (Ge.validateInput("fileAsync", a, c), new Promise((l, f) => {
      Ge.async(r(a), c).then(() => {
        l(o);
      }, f);
    })),
    find: (a, c) => (typeof c > "u" && typeof a == "object" && (c = a, a = "."), Ye.validateInput("find", a, c), Ye.sync(r(a), i(c))),
    findAsync: (a, c) => (typeof c > "u" && typeof a == "object" && (c = a, a = "."), Ye.validateInput("findAsync", a, c), Ye.async(r(a), i(c))),
    inspect: (a, c) => (Ze.validateInput("inspect", a, c), Ze.sync(r(a), c)),
    inspectAsync: (a, c) => (Ze.validateInput("inspectAsync", a, c), Ze.async(r(a), c)),
    inspectTree: (a, c) => (et.validateInput("inspectTree", a, c), et.sync(r(a), c)),
    inspectTreeAsync: (a, c) => (et.validateInput("inspectTreeAsync", a, c), et.async(r(a), c)),
    list: (a) => (rt.validateInput("list", a), rt.sync(r(a || "."))),
    listAsync: (a) => (rt.validateInput("listAsync", a), rt.async(r(a || "."))),
    move: (a, c, l) => {
      st.validateInput("move", a, c, l), st.sync(r(a), r(c), l);
    },
    moveAsync: (a, c, l) => (st.validateInput("moveAsync", a, c, l), st.async(r(a), r(c), l)),
    read: (a, c) => (it.validateInput("read", a, c), it.sync(r(a), c)),
    readAsync: (a, c) => (it.validateInput("readAsync", a, c), it.async(r(a), c)),
    remove: (a) => {
      ot.validateInput("remove", a), ot.sync(r(a || "."));
    },
    removeAsync: (a) => (ot.validateInput("removeAsync", a), ot.async(r(a || "."))),
    rename: (a, c, l) => {
      at.validateInput("rename", a, c, l), at.sync(r(a), c, l);
    },
    renameAsync: (a, c, l) => (at.validateInput("renameAsync", a, c, l), at.async(r(a), c, l)),
    symlink: (a, c) => {
      ct.validateInput("symlink", a, c), ct.sync(a, r(c));
    },
    symlinkAsync: (a, c) => (ct.validateInput("symlinkAsync", a, c), ct.async(a, r(c))),
    tmpDir: (a) => {
      lt.validateInput("tmpDir", a);
      const c = lt.sync(e(), a);
      return n(c);
    },
    tmpDirAsync: (a) => (lt.validateInput("tmpDirAsync", a), new Promise((c, l) => {
      lt.async(e(), a).then((f) => {
        c(n(f));
      }, l);
    })),
    write: (a, c, l) => {
      ft.validateInput("write", a, c, l), ft.sync(r(a), c, l);
    },
    writeAsync: (a, c, l) => (ft.validateInput("writeAsync", a, c, l), ft.async(r(a), c, l))
  };
  return Ir.inspect.custom !== void 0 && (o[Ir.inspect.custom] = () => `[fs-jetpack CWD: ${e()}]`), o;
};
var Vl = Ai;
const Kl = Vl;
var Ql = Kl();
const of = /* @__PURE__ */ Dr(Ql);
class af {
  axios;
  constructor(e) {
    this.axios = R.create({ baseURL: e });
  }
  async loadPolicy(e) {
    try {
      return (await this.axios.get(e)).data;
    } catch (n) {
      throw n.response?.status === 404 ? new Ti(e, n) : n;
    }
  }
}
export {
  ha as A,
  va as B,
  of as C,
  ra as D,
  nf as E,
  R as F,
  le as M,
  Z as N,
  H as P,
  af as R,
  k as S,
  me as Y,
  us as a,
  Ut as b,
  tf as c,
  qn as d,
  qe as e,
  Ea as f,
  De as g,
  I as h,
  _t as i,
  St as j,
  z as k,
  oe as l,
  ua as m,
  da as n,
  ef as o,
  Zl as p,
  bt as q,
  j as r,
  Sa as s,
  ya as t,
  N as u,
  gr as v,
  W as w,
  Re as x,
  Yl as y,
  P as z
};
